<template>
  <div id="app">
    <el-container>
      <el-header height="115px">
        <v-topbar></v-topbar>
        <v-header :navindex="0"></v-header>
      </el-header>
      <el-main class="home">
        <div class="banner">
          <!--轮播-->
          <el-carousel height="400px" arrow="never">
            <el-carousel-item class="slide-03">
              <div class="threeLang">
                <img
                  v-if="locale === 'zh_CN'"
                  src="../home/img/banner-word.png"
                  class="ban_word"
                  alt=""
                />
                <img
                  v-else-if="locale === 'zh_TW'"
                  src="../home/img/banner-word-ft.png"
                  class="ban_word"
                  alt=""
                />
                <img
                  v-else
                  src="../home/img/banner-word-en.png"
                  class="ban_word"
                  alt=""
                />
              </div>
            </el-carousel-item>
            <el-carousel-item class="slide-01"></el-carousel-item>
            <el-carousel-item class="slide-02"></el-carousel-item>
          </el-carousel>
          <div class="swiper"></div>
          <div class="banner-actionbox">
            <div class="banner-action" v-show="islogin">
              <template v-if="!headUrl">
                <img
                  src="@/publicResource/common/img/avatar_user_female.png"
                  v-if="userSex === 'FEMALE'"
                  alt="用户头像"
                />
                <img
                  src="@/publicResource/common/img/avatar_user_male.png"
                  v-else
                  alt="用户头像"
                />
              </template>
              <img :src="headUrl" v-else alt="用户头像" />
              <div class="welcome-login">
                {{ $t('home.welcome') }}{{ mobilephone }}
              </div>
              <div class="usercenter btnlr-gradient">
                <a @click="isRealName1()">{{ $t('home.personalCenter') }}</a>
              </div>
              <div class="loginout">
                <a href @click.prevent="loginout">{{ $t('home.exit') }}</a>
              </div>
            </div>
            <div class="banner-action" v-show="!islogin">
              <logintab :loginpage="'home'" @haslogined="hasLogined"></logintab>
            </div>
          </div>
        </div>

        <!-- <div class="case-count">
            <div class="count-box">
              <div>
                {{$t('home.mediation')}}
                <span v-for="(item,index) in mediateCount" :key="index">{{item}}</span>
                <p>{{$t('home.case')}}</p>
              </div>
              <div>
                智能咨询:
                <span v-for="(item,index) in iACount" :key="index">{{item}}</span>
                <p>例</p>
              </div>
          </div>
        </div> -->
        <!-- <el-button style="margin: 0 auto" type="warning" plain @click="mediation">申请调解</el-button> -->

        <!-- <div class="law-consult">
          <div class="box-h">
            <h5 class="h5tit">服务内容</h5>
            <p class="pdesc">多元资源专业支持，矛盾纠纷快速化解</p>
            <div class="line">
            <span class="orange"></span>
            <span class="blue"></span>
            </div>
          </div>
          <ul class="clearfix">
            <li>
              <i class="icon02"></i>
              <h6>在线调解</h6>
              <p>结合线上和线下双重渠道，汇聚多元优质解纷资源，提供专业的深度调解服务。</p>
              <img src="../../module/home/img/consult_02.png" alt="人工咨询">
              <a href @click.prevent="handleCloseEnter">查看</a>
            </li>
            <li>
              <i class="icon01"></i>
              <h6>智能咨询</h6>
              <p>智能咨询24小时在线服务，问答模块无缝对接百姓生活；人工咨询与专业律师一 对一交流，满足个性化法律需求。</p>
              <img src="../../module/home/img/consult_01.png" alt="智能咨询">
              <a href @click.prevent="showMes=true">我要咨询</a>
            </li>
          </ul>
        </div> -->
        <!-- 海南自贸区-->
        <div class="fta-box">
          <div class="fta-box-main">
            <div class="fta-main">
              <div class="fta-item fta-item1">
                <div class="fta-item-title">{{ $t('home.wholeProgress') }}</div>
                <div class="fta-item-text">
                  {{ $t('home.SMSNotification') }}
                </div>
              </div>
              <div class="fta-item fta-item2">
                <div class="fta-item-title">{{ $t('home.qualityTeam') }}</div>
                <div class="fta-item-text">{{ $t('home.qualityTeam2') }}</div>
              </div>
              <div class="fta-item fta-item3">
                <div class="fta-item-title">{{ $t('home.saveTime') }}</div>
                <div class="fta-item-text">{{ $t('home.saveTime2') }}</div>
              </div>
            </div>
          </div>
          <div class="dispute-numbox">
            <span class="numtitle">{{ $t('home.mediation') }}</span>
            <span class="numbox"
              ><span v-for="(item, index) in mediateCount" :key="index">{{
                item
              }}</span></span
            >
            <span class="numtitle">{{ $t('home.case') }}</span>
          </div>
          <div class="fta-btnbox" @click="openFta">
            <div class="fta-img"><img src="./img/fta.png" alt="" /></div>

            <div class="fta-divtext">海南自贸区</div>
          </div>
        </div>
        <!-- 案例库-->
        <div class="case-box">
          <div class="casebase-div1 myrow">
            <span>{{ this.$t('header.caseLibrary') }}</span
            ><span>Case Library</span>
          </div>
          <div class="casebase-div2 myrow">
            <div class="div2-left">
              <div class="content-box content2-box" v-if="isContent[0]">
                <div class="content-title">{{ $t('home.title2') }}</div>
                <div class="content-text">{{ $t('home.content2') }}</div>
                <div class="content-btn" @click="newgoToCaseDetail(2)">
                  <el-button style="margin: 0 auto" type="warning" plain>{{
                    $t('home.learnMore')
                  }}</el-button>
                </div>
              </div>
              <div class="content-box content1-box" v-if="isContent[1]">
                <div class="content-title">{{ $t('home.title1') }}</div>
                <div class="content-text">{{ $t('home.content1') }}</div>
                <div class="content-btn" @click="newgoToCaseDetail(1)">
                  <el-button style="margin: 0 auto" type="warning" plain
                    >了解详情</el-button
                  >
                </div>
              </div>
              <div class="content-box content3-box" v-if="isContent[2]">
                <div class="content-title">{{ $t('home.title3') }}</div>
                <div class="content-text">{{ $t('home.content3') }}</div>
                <div class="content-btn" @click="newgoToCaseDetail(3)">
                  <el-button style="margin: 0 auto" type="warning" plain
                    >了解详情</el-button
                  >
                </div>
              </div>
            </div>
            <div class="div2-right">
              <div
                class="right-top hover-box"
                @click="newgoToCaseDetail(2)"
                @mouseenter="ContentIn(0)"
              >
                <div class="top-title">{{ $t('home.title2') }}</div>
              </div>
              <div class="right-down">
                <div
                  class="down-div1 hover-box"
                  @click="newgoToCaseDetail(1)"
                  @mouseenter="ContentIn(1)"
                >
                  <div class="down-title">{{ $t('home.title1') }}</div>
                </div>
                <div
                  class="down-div2 hover-box"
                  @click="newgoToCaseDetail(3)"
                  @mouseenter="ContentIn(2)"
                >
                  <div class="down-title">{{ $t('home.title3') }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 新法律法规 -->
        <div class="law-box">
          <div class="law-div1 myrow">
            <span>{{ $t('header.lawsAndRegulations') }}</span
            ><span>Laws and Regulations</span>
          </div>
          <div class="law-main myrow">
            <div class="law-bgimg"></div>
            <a href="javascript:;" class="law-morebtn" @click="moreLaw"
              >{{ $t('header.more') }} >></a
            >
            <div class="law-maindiv">
              <div @click="openNewTab(0)">
                <div class="law-time"><span>01</span><span>2018.08</span></div>
                <div class="law-item">
                  <div class="lawitem-title">
                    {{ $t('lawsAndRegulations.title1') }}
                  </div>
                  <div class="lawitem-text">
                    <p>
                      {{ $t('lawsAndRegulations.desc1') }}
                    </p>
                  </div>
                </div>
              </div>
              <div @click="openNewTab(1)">
                <div class="law-time"><span>24</span><span>2018.09</span></div>
                <div class="law-item">
                  <div class="lawitem-title">
                    {{ $t('lawsAndRegulations.title2') }}
                  </div>
                  <div class="lawitem-text">
                    <p>
                      {{ $t('lawsAndRegulations.desc2') }}
                    </p>
                  </div>
                </div>
              </div>
              <div @click="openNewTab(2)">
                <div class="law-time"><span>26</span><span>2014.09</span></div>
                <div class="law-item">
                  <div class="lawitem-title">
                    {{ $t('lawsAndRegulations.title3') }}
                  </div>
                  <div class="lawitem-text">
                    <p>
                      {{ $t('lawsAndRegulations.desc3') }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 法律法规 -->
        <!--        <div class="law-one">-->
        <!--          <div class="box-h">-->
        <!--            <h5 class="h5tit" style="color:#333">法律法规</h5>-->
        <!--            <div class="line">-->
        <!--              <span></span>-->
        <!--              <p class="pdesc" style="color:#888">相关法律法规知识</p>-->
        <!--              <span></span>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div class="clear">-->
        <!--            <el-row>-->
        <!--                <el-col :span="11" style="margin-right: 100px">-->
        <!--                  <ul>-->
        <!--                    <li class="fist-news">-->
        <!--                        <a href @click.prevent="goToLawDeatil(firstNews.id)">-->
        <!--                            <img src="./img/first.png">-->
        <!--                            <div style="width: 400px">-->
        <!--                                <h3 class="title">{{firstNews.title}}</h3>-->
        <!--                                <span class="time">{{firstNews.publishDate}}</span>-->
        <!--                                <span class="content" style="-webkit-box-orient: vertical;">{{firstNews.simpleContent}}</span>-->
        <!--                            </div>-->
        <!--                        </a>-->
        <!--                    </li>-->
        <!--                    <li class="other-news" v-for="(item,index) in secondNews" :key="index">-->
        <!--                        <a href  @click.prevent="goToLawDeatil(item.id)">-->
        <!--                            <h3 class="title">{{item.title}}</h3>-->
        <!--                            <span class="time">{{item.publishDate}}</span>-->
        <!--                        </a>-->
        <!--                    </li>-->
        <!--                     &lt;!&ndash; <li class="other-news">-->
        <!--                        <a href="#">-->
        <!--                            <h3 class="title">广州中院公开宣判两起涉黑涉恶案件 3人死缓2人无期</h3>-->
        <!--                            <span class="time">2018-02-12</span>-->
        <!--                        </a>-->
        <!--                    </li>-->
        <!--                     <li class="other-news">-->
        <!--                        <a href="#">-->
        <!--                            <h3 class="title">广州中院公开宣判两起涉黑涉恶案件 3人死缓2人无期</h3>-->
        <!--                            <span class="time">2018-02-12</span>-->
        <!--                        </a>-->
        <!--                    </li>-->
        <!--                     <li class="other-news">-->
        <!--                        <a href="#">-->
        <!--                            <h3 class="title">广州中院公开宣判两起涉黑涉恶案件 3人死缓2人无期</h3>-->
        <!--                            <span class="time">2018-02-12</span>-->
        <!--                        </a>-->
        <!--                    </li> &ndash;&gt;-->
        <!--                  </ul>-->
        <!--                </el-col>-->
        <!--                <el-col :span="11">-->
        <!--                  <ul>-->
        <!--                    <li class="fist-news">-->
        <!--                        <a href @click.prevent="goToLawDeatil(secondNews1.id)">-->
        <!--                            <img src="./img/second.png">-->
        <!--                            <div style="width: 400px">-->
        <!--                                <h3 class="title">{{secondNews1.title}}</h3>-->
        <!--                                <span class="time">{{secondNews1.publishDate}}</span>-->
        <!--                                <span class="content" style="-webkit-box-orient: vertical;">{{secondNews1.simpleContent}}</span>-->
        <!--                            </div>-->
        <!--                        </a>-->
        <!--                    </li>-->
        <!--                    <li class="other-news" v-for="(item,index) in thirdNews" :key="index">-->
        <!--                        <a href @click.prevent="goToLawDeatil(item.id)">-->
        <!--                            <h3 class="title">{{item.title}}</h3>-->
        <!--                            <span class="time">{{item.publishDate}}</span>-->
        <!--                        </a>-->
        <!--                    </li>-->
        <!--                  </ul>-->
        <!--                </el-col>-->
        <!--            </el-row>-->
        <!--          </div>-->
        <!--        </div>-->

        <!--<div class="law-consult-two">
            <div class="box-h">
              <h5 class="h5tit" style="color:#333">案例库</h5>
              <div class="line">
                <span></span>
                <p class="pdesc" style="color:#888">提供相关案例知识</p>
                <span></span>
              </div>
              <iframe id="redir" src width="1px" height="1px"></iframe>
            </div>
            <div class="clearfix" style="position: relative">
              <el-row>
                <el-col>
                  <el-card :body-style="{ padding: '20px' }">
                    <a href="javascript:;">
                      <img src="../../module/home/img/01.png" class="cir">
                      <img src="../../module/home/img/dispute01.png" class="image">
                      <div class="card-body">
                        <h6>{{$t('home.title1')}}</h6>
                        <p>{{$t('home.content1')}}</p>
                        <div class="card-btn" @click="goToCaseDetail('gangaotai')">
                          <el-button style="margin: 0 auto" type="warning" plain>{{$t('role.view')}}</el-button>
                        </div>
                      </div>
                    </a>
                  </el-card>
                </el-col>
                <el-col>
                  <el-card :body-style="{ padding: '20px' }">
                    <a href="javascript:;">
                      <img src="../../module/home/img/02.png" class="cir">
                      <img src="../../module/home/img/dispute02.png" class="image">
                      <div class="card-body">
                        <h6>{{$t('home.title2')}}</h6>
                        <p>{{$t('home.content2')}}</p>
                        <div class="card-btn" @click="goToCaseDetail('guidingCase')">
                          <el-button style="margin: 0 auto" type="warning" plain>{{$t('role.view')}}</el-button>
                        </div>
                      </div>
                    </a>
                  </el-card>
                </el-col>
                <el-col>
                  <el-card :body-style="{ padding: '20px' }">
                    <a href="javascript:;">
                      <img src="../../module/home/img/03.png" class="cir">
                      <img src="../../module/home/img/dispute03.png" class="image">
                      <div class="card-body" @click="goToCaseDetail('shewai')">
                        <h6>{{$t('home.title3')}}</h6>
                        <p>{{$t('home.content3')}}</p>
                        <div class="card-btn">
                          <el-button style="margin: 0 auto" type="warning" plain>{{$t('role.view')}}</el-button>
                        </div>
                      </div>
                    </a>
                  </el-card>
                </el-col>
              </el-row>
            </div>

            <img src="./img/consult_type.png" alt="纠纷类型" class="dispute-type">
        </div>-->
        <!--<div class="lawsuit-third">
            <div class="box-h">
              <h5 class="h5tit">诉讼服务</h5>
              <p class="pdesc">对接网上立案系统，实现诉讼案件的立案、举证、质证、开庭、宣判和送达服务。</p>
              <div class="line"><span class="orange"></span><span class="blue"></span></div>
            </div>
            <div class="action-btn" @click="tolink('susong')">我要诉讼</div>
          </div>-->
        <!--        <div class="online-defuse">-->
        <!--          <div class="box-h">-->
        <!--            <h5 class="h5tit">{{$t('home.onlineDisputeResolution')}}</h5>-->
        <!--            <div class="line">-->
        <!--              <span></span>-->
        <!--              <p class="pdesc" style="color:#888">{{$t('home.onlineDisputeResolution2')}}</p>-->
        <!--              <span></span>-->
        <!--            </div>-->
        <!--            &lt;!&ndash;<div class="line">&ndash;&gt;-->
        <!--            &lt;!&ndash;<span class="orange"></span>&ndash;&gt;-->
        <!--            &lt;!&ndash;<span class="blue"></span>&ndash;&gt;-->
        <!--            &lt;!&ndash;</div>&ndash;&gt;-->
        <!--          </div>-->
        <!--          <ul class="clearfix">-->
        <!--            <li>-->
        <!--              &lt;!&ndash; <i class="icon02"></i> &ndash;&gt;-->
        <!--              <img src="../../module/home/img/el01.png" alt="">-->
        <!--              <div>{{$t('home.qualityTeam')}}</div>-->
        <!--              <p>{{$t('home.qualityTeam2')}}</p>-->
        <!--            </li>-->
        <!--            <li>-->
        <!--              &lt;!&ndash; <i class="icon03"></i> &ndash;&gt;-->
        <!--              <img src="../../module/home/img/el02.png" alt="">-->
        <!--              <div>{{$t('home.saveTime')}}</div>-->
        <!--              <p>{{$t('home.saveTime2')}}</p>-->
        <!--            </li>-->
        <!--            <li>-->
        <!--              &lt;!&ndash; <i class="icon04"></i> &ndash;&gt;-->
        <!--              <img src="../../module/home/img/el03.png" alt="">-->
        <!--              <div>{{$t('home.wholeProgress')}}</div>-->
        <!--              <p>{{$t('home.SMSNotification')}}</p>-->
        <!--            </li>-->
        <!--          </ul>-->
        <!--        </div>-->
        <!-- 服务资源-->
        <div class="service-source">
          <!--          <div class="box-h">-->
          <!--            <h5 class="h5tit">{{$t('header.serviceResources')}}</h5>-->
          <!--            <div class="line">-->
          <!--              <span></span>-->
          <!--              <p class="pdesc">{{$t('home.professional')}}</p>-->
          <!--              <span></span>-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="service-div1 myrow">
            <span>{{ $t('header.serviceResources') }}</span
            ><span>Service Resources</span>
          </div>
          <ul class="clearfix">
            <li v-for="(item, index) in countList2" :key="index">
              <h6>{{ item.resourceNumber | formatToMoney }}</h6>
              <p>{{ item.resourceName }}</p>
            </li>
          </ul>
        </div>
        <!-- <div class="partners">
        <div class="box-h">
          <h5 class="h5tit">合作伙伴</h5>
          <div class="line"><span class="orange"></span><span class="blue"></span></div>
        </div>
        <div class="partners-img"><img src="../../module/home/img/partners.png" alt="合作伙伴"/></div>
        </div>-->
        <!--<div class="talk-service">-->
        <!--<a :href="robot.robotHost" target="_blank"></a>-->
        <!--</div>-->
      </el-main>
      <!-- <el-dialog class="peoDialog" title="温馨提示" :visible.sync="showMes" width="420px">
        <span class="sucess-sub">本次咨询仅供参考，不能替代任何司法判决或证据使用，不能代表广州互联网法院观点。</span>
        <el-row class="sucess-btn">
          <el-button @click="showMes=false" plain class="btn">取消</el-button>
          <el-button @click="showMessage(robot.robotHost)" type="primary" class="btn">
            <span style="color:white">确定</span>
          </el-button>
        </el-row>
      </el-dialog> -->
      <el-dialog
        class="peoDialog"
        title="温馨提示"
        :visible.sync="dialogTableVisiblePeoTime"
        width="420px"
        :before-close="handleClose1"
      >
        <div class="conDialog">
          <div class="tipDialog">
            <!--<span class="sucess-sub">您当前为游客身份，无对应账户。-->
            <!--<br>故咨询内容无法保存，如需保存咨询内容，可先登录，再发起咨询。-->
            <!--</span>-->
            <span class="sucess-sub">需要登录后可以查看纠纷调解页面</span>
          </div>
        </div>
        <el-row class="sucess-btn">
          <a href="/mediation.html">
            <el-button plain class="btn">查看</el-button>
          </a>
          <a href="/useraction/login">
            <el-button type="primary" class="btn">{{
              $t('home.login')
            }}</el-button>
          </a>
        </el-row>
      </el-dialog>
      <el-dialog
        class="peoDialog"
        title="温馨提示"
        :visible.sync="dialogTableVisiblePeoNoTime"
        width="420px"
        :before-close="handleClose2"
      >
        <div class="conDialog">
          <div class="tipDialog">
            <span class="sucess-sub" v-if="isCustomer">
              咨询师工作时间为：
              <br />周一至周五09:00~11:30;13:30~18:00；
              <br />仍要现在发起咨询，请登录，提交咨询留言，
              <br />咨询师会于工作时间及时回复您，谢谢！
            </span>
            <span class="sucess-sub" v-if="!isCustomer">
              咨询师工作时间为：
              <br />周一至周五09:00~11:30;13:30~18:00；
              <br />当前时间咨询，咨询师会于上班后第一时间回复您，谢谢！
            </span>
          </div>
        </div>
        <el-row class="sucess-btn">
          <el-button plain class="btn" @click="handleCloseEnter"
            >确定</el-button
          >
          <a href="/useraction/login" v-if="isCustomer">
            <el-button type="primary" class="btn">登录</el-button>
          </a>
        </el-row>
      </el-dialog>
      <el-dialog
        class="ftaDialog"
        title="海南自贸区"
        :visible.sync="dialogTableVisibleFta"
        width="902px"
        :before-close="handleClose3"
      >
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            label="关于支持海南全面深化改革开放的指导意见"
            name="first"
          >
            <el-scrollbar tag="section">
              <div>
                <p>
                  海南建省和兴办经济特区是党中央着眼于我国改革开放和社会主义现代化建设全局作出的重大战略决策。2018年是贯彻党的十九大精神的开局之年，是改革开放40周年，也是海南建省和兴办经济特区30周年。在新的历史条件下，为全面贯彻党的十九大精神和习近平总书记重要批示精神，更进一步凸显我国改革开放40年的重大意义，更进一步彰显党的十八大以来习近平总书记带领全国各族人民全面深化改革开放的重大意义，推动海南成为新时代全面深化改革开放的新标杆，形成更高层次改革开放新格局，探索实现更高质量、更有效率、更加公平、更可持续的发展，现提出以下意见。
                </p>
                <p>一、重大意义</p>
                <p>
                  海南省因改革开放而生，也因改革开放而兴。1988年，党中央批准海南建省办经济特区。30年来，海南省切实履行党中央、国务院赋予的历史使命，大胆创新、奋勇拼搏，推动经济社会发展取得重大成就，把一个边陲海岛发展成为我国改革开放的重要窗口，实现了翻天覆地的变化，为全国提供了宝贵经验。实践证明，党中央关于海南建省和兴办经济特区的决策是完全正确的。
                </p>
                <p>
                  在中国特色社会主义进入新时代的大背景下，赋予海南经济特区改革开放新的使命，是习近平总书记亲自谋划、亲自部署、亲自推动的重大国家战略，必将对构建我国改革开放新格局产生重大而深远影响。支持海南全面深化改革开放有利于探索可复制可推广的经验，压茬拓展改革广度和深度，完善和发展中国特色社会主义制度；有利于我国主动参与和推动经济全球化进程，发展更高层次的开放型经济，加快推动形成全面开放新格局；有利于推动海南加快实现社会主义现代化，打造成新时代中国特色社会主义新亮点，彰显中国特色社会主义制度优越性，增强中华民族的凝聚力和向心力。
                </p>
                <p>二、总体要求</p>
                <p>
                  （一）指导思想。全面贯彻党的十九大和十九届二中、三中全会精神，以习近平新时代中国特色社会主义思想为指导，坚持党的全面领导，坚持稳中求进工作总基调，坚持新发展理念，统筹推进
                  “五位一体”总体布局和协调推进“四个全面”战略布局，以供给侧结构性改革为主线，赋予海南经济特区改革开放新使命，建设自由贸易试验区和中国特色自由贸易港，解放思想、大胆创新，着力在建设现代化经济体系、实现高水平对外开放、提升旅游消费水平、服务国家重大战略、加强社会治理、打造一流生态环境、完善人才发展制度等方面进行探索，在贯彻落实党的十九大的重大决策部署上走在前列，打造实践中国特色社会主义的生动范例，开创新时代中国特色社会主义新局面，为把我国建设成为富强民主文明和谐美丽的社会主义现代化强国作出更大贡献。
                </p>
                <p>
                  （二）战略定位
                  ——全面深化改革开放试验区。大力弘扬敢闯敢试、敢为人先、埋头苦干的特区精神，在经济体制改革和社会治理创新等方面先行先试。适应经济全球化新形势，实行更加积极主动的开放战略，探索建立开放型经济新体制，把海南打造成为我国面向太平洋和印度洋的重要对外开放门户。
                  ——国家生态文明试验区。牢固树立和践行绿水青山就是金山银山的理念，坚定不移走生产发展、生活富裕、生态良好的文明发展道路，推动形成人与自然和谐发展的现代化建设新格局，为推进全国生态文明建设探索新经验。
                  ——国际旅游消费中心。大力推进旅游消费领域对外开放，积极培育旅游消费新热点，下大气力提升服务质量和国际化水平，打造业态丰富、品牌集聚、环境舒适、特色鲜明的国际旅游消费胜地。
                  ——国家重大战略服务保障区。深度融入海洋强国、
                  “一带一路”建设、军民融合发展等重大战略，全面加强支撑保障能力建设，切实履行好党中央赋予的重要使命，提升海南在国家战略格局中的地位和作用。
                </p>
                <p>
                  （三）基本原则
                  ——坚持和加强党对改革开放的领导。把党的领导贯穿于海南全面深化改革开放的全过程，增强
                  “四个意识”，坚定
                  “四个自信”，自觉维护以习近平同志为核心的党中央权威和集中统一领导，培育践行社会主义核心价值观，确保改革开放的社会主义方向。
                  ——坚持整体推进和稳步实施。强化顶层设计，增强改革的系统性、协调性，使各项改革举措相互配合、相得益彰，提高改革整体效益。科学把握改革举措实施步骤，加强风险评估和跟踪预警，注重纠错调整，积极防范潜在风险。
                  ——坚持统筹陆地和海洋保护发展。加强海洋生态文明建设，加大海洋保护力度，加强海洋权益维护，科学有序开发利用海洋资源，培育壮大特色海洋经济，形成陆海资源、产业、空间互动协调发展新格局。
                  ——坚持发挥人才的关键性作用。坚持人才是第一资源，在人才培养、引进、使用上大胆创新，聚天下英才而用之，努力让各类人才引得进、留得住、用得好，使海南成为人才荟萃之岛、技术创新之岛。
                </p>
                <p>
                  （四）发展目标
                  到2020年，与全国同步实现全面建成小康社会目标，确保现行标准下农村贫困人口实现脱贫，贫困县全部摘帽；自由贸易试验区建设取得重要进展，国际开放度显著提高；公共服务体系更加健全，人民群众获得感明显增强；生态文明制度基本建立，生态环境质量持续保持全国一流水平。
                  到2025年，经济增长质量和效益显著提高；自由贸易港制度初步建立，营商环境达到国内一流水平；民主法制更加健全，治理体系和治理能力现代化水平明显提高；公共服务水平和质量达到国内先进水平，基本公共服务均等化基本实现；生态环境质量继续保持全国领先水平。
                  到2035年，在社会主义现代化建设上走在全国前列；自由贸易港的制度体系和运作模式更加成熟，营商环境跻身全球前列；人民生活更为宽裕，全体人民共同富裕迈出坚实步伐，优质公共服务和创新创业环境达到国际先进水平；生态环境质量和资源利用效率居于世界领先水平；现代社会治理格局基本形成，社会充满活力又和谐有序。
                  到本世纪中叶，率先实现社会主义现代化，形成高度市场化、国际化、法治化、现代化的制度体系，成为综合竞争力和文化影响力领先的地区，全体人民共同富裕基本实现，建成经济繁荣、社会文明、生态宜居、人民幸福的美好新海南。
                </p>
                <p>三、建设现代化经济体系</p>
                <p>
                  坚持质量第一、效益优先，以供给侧结构性改革为主线，推动经济发展质量变革、效率变革、动力变革，提高全要素生产率，加快建立开放型生态型服务型产业体系，进一步完善社会主义市场经济体制，不断增强海南的经济创新力和竞争力。
                </p>
                <p>
                  （五）深化供给侧结构性改革。坚持把实体经济作为发展经济的着力点，紧紧围绕提高供给体系质量，支持海南传统产业优化升级，加快发展现代服务业，培育新动能。推动旅游业转型升级，加快构建以观光旅游为基础、休闲度假为重点、文体旅游和健康旅游为特色的旅游产业体系，推进全域旅游发展。瞄准国际先进水平，大力发展现代服务业，加快服务贸易创新发展。统筹实施网络强国战略、大数据战略、
                  “互联网+”行动，大力推进新一代信息技术产业发展，推动互联网、物联网、大数据、卫星导航、人工智能和实体经济深度融合。鼓励发展虚拟现实技术，大力发展数字创意产业。高起点发展海洋经济，积极推进南海天然气水合物、海底矿物商业化开采，鼓励民营企业参与南海资源开发，加快培育海洋生物、海水淡化与综合利用、海洋可再生能源、海洋工程装备研发与应用等新兴产业，支持建设现代化海洋牧场。实施乡村振兴战略，做强做优热带特色高效农业，打造国家热带现代农业基地，支持创设海南特色农产品期货品种，加快推进农业农村现代化。
                </p>
                <p>
                  （六）实施创新驱动发展战略。面向深海探测、海洋资源开发利用、航天应用等战略性领域，支持海南布局建设一批重大科研基础设施与条件平台，建设航天领域重大科技创新基地和国家深海基地南方中心，打造空间科技创新战略高地。加强国家南繁科研育种基地（海南）建设，打造国家热带农业科学中心，支持海南建设全球动植物种质资源引进中转基地。设立海南国际离岸创新创业示范区。建立符合科研规律的科技创新管理制度和国际科技合作机制。鼓励探索知识产权证券化，完善知识产权信用担保机制。
                </p>
                <p>
                  （七）深入推进经济体制改革。深化国有企业改革，推进集团层面混合所有制改革，健全公司法人治理结构，完善现代企业制度。完善各类国有资产管理体制，探索政府直接授权国有资本投资、运营公司，加快国有企业横向联合、纵向整合和专业化重组，推动国有资本做强做优做大。完善产权保护制度，加强政务诚信和营商环境建设，清理废除妨碍统一市场和公平竞争的规定与做法，严厉打击不正当竞争行为，激发和保护企业家精神，支持民营企业发展，鼓励更多市场主体和社会主体投身创新创业。深化农垦改革，推进垦区集团化、农场企业化改革，有序推行土地资产化和资本化，鼓励社会资本通过设立农业产业投资基金、农垦产业发展股权投资基金等方式，参与农垦项目和国有农场改革。扎实推进房地一体的农村集体建设用地和宅基地使用权确权登记颁证，在海南全省统筹推进农村土地征收、集体经营性建设用地入市、宅基地制度改革试点，建立不同权属、不同用途建设用地合理比价调节机制和增值收益分配机制，统筹不同地区、拥有不同类型土地的农民收益。支持依法合规在海南设立国际能源、航运、大宗商品、产权、股权、碳排放权等交易场所。创新投融资方式，规范运用政府和社会资本合作（PPP）模式，引导社会资本参与基础设施和民生事业。支持海南以电力和天然气体制改革为重点，开展能源综合改革。理顺民用机场管理体制，先行先试通用航空分类管理改革。
                </p>
                <p>
                  （八）提高基础设施网络化智能化水平。按照适度超前、互联互通、安全高效、智能绿色的原则，大力实施一批重大基础设施工程，加快构建现代基础设施体系。建设
                  “数字海南”，推进城乡光纤网络和高速移动通信网络全覆盖，加快实施信息进村入户工程，着力提升南海海域通信保障能力。落实国家网络安全等级保护制度，提升网络安全保障水平。推进海口机场改扩建工程，开展三亚新机场、儋州机场、东方/五指山机场前期工作，加密海南直达全球主要客源地的国际航线。优化整合港口资源，重点支持海口、洋浦港做优做强。推进电网主网架结构建设和城乡电网智能化升级改造，开展智能电网、微电网等示范项目建设。构建覆盖城乡的供气管网。加强城市地下空间利用和综合管廊建设。完善海岛型水利设施网络。
                </p>
                <p>四、推动形成全面开放新格局</p>
                <p>
                  坚持全方位对外开放，按照先行先试、风险可控、分步推进、突出特色的原则，第一步，在海南全境建设自由贸易试验区，赋予其现行自由贸易试验区试点政策；第二步，探索实行符合海南发展定位的自由贸易港政策。
                </p>
                <p>
                  （九）高标准高质量建设自由贸易试验区。以现有自由贸易试验区试点内容为主体，结合海南特点，建设中国（海南）自由贸易试验区，实施范围为海南岛全岛。以制度创新为核心，赋予更大改革自主权，支持海南大胆试、大胆闯、自主改，加快形成法治化、国际化、便利化的营商环境和公平统一高效的市场环境。更大力度转变政府职能，深化简政放权、放管结合、优化服务改革，全面提升政府治理能力。实行高水平的贸易和投资自由化便利化政策，对外资全面实行准入前国民待遇加负面清单管理制度，围绕种业、医疗、教育、体育、电信、互联网、文化、维修、金融、航运等重点领域，深化现代农业、高新技术产业、现代服务业对外开放，推动服务贸易加快发展，保护外商投资合法权益。推进航运逐步开放。发挥海南岛全岛试点的整体优势，加强改革系统集成，力争取得更多制度创新成果，彰显全面深化改革和扩大开放试验田作用。
                </p>
                <p>
                  （十）探索建设中国特色自由贸易港。根据国家发展需要，逐步探索、稳步推进海南自由贸易港建设，分步骤、分阶段建立自由贸易港政策体系。海南自由贸易港建设要体现中国特色，符合海南发展定位，学习借鉴国际自由贸易港建设经验，不以转口贸易和加工制造为重点，而以发展旅游业、现代服务业和高新技术产业为主导，更加强调通过人的全面发展，充分激发发展活力和创造力，打造更高层次、更高水平的开放型经济。及时总结59国外国人入境旅游免签政策实施效果，加大出入境安全措施建设，为进一步扩大免签创造条件。完善国际贸易
                  “单一窗口”等信息化平台。积极吸引外商投资以及先进技术、管理经验，支持外商全面参与自由贸易港建设。在内外贸、投融资、财政税务、金融创新、出入境等方面探索更加灵活的政策体系、监管模式和管理体制，打造开放层次更高、营商环境更优、辐射作用更强的开放新高地。
                </p>
                <p>
                  （十一）加强风险防控体系建设。出台有关政策要深入论证、严格把关，成熟一项推出一项。打好防范化解重大风险攻坚战，有效履行属地金融监管职责，构建金融宏观审慎管理体系，建立金融监管协调机制，加强对重大风险的识别和系统性金融风险的防范，严厉打击洗钱、恐怖融资及逃税等金融犯罪活动，有效防控金融风险。优化海关监管方式，强化进出境安全准入管理，完善对国家禁止和限制入境货物、物品的监管，高效精准打击走私活动。建立检验检疫风险分类监管综合评定机制。强化企业投资经营事中事后监管，实行
                  “双随机、一公开”监管全覆盖。
                </p>
                <p>五、创新促进国际旅游消费中心建设的体制机制</p>
                <p>
                  深入推进国际旅游岛建设，不断优化发展环境，进一步开放旅游消费领域，积极培育旅游消费新业态、新热点，提升高端旅游消费水平，推动旅游消费提质升级，进一步释放旅游消费潜力，积极探索消费型经济发展的新路径。
                </p>
                <p>
                  （十二）拓展旅游消费发展空间。实施更加开放便利的离岛免税购物政策，实现离岛旅客全覆盖，提高免税购物限额。支持海南开通跨国邮轮旅游航线，支持三亚等邮轮港口开展公海游航线试点，加快三亚向邮轮母港方向发展。放宽游艇旅游管制。有序推进西沙旅游资源开发，稳步开放海岛游。全面落实完善博鳌乐城国际医疗旅游先行区政策，鼓励医疗新技术、新装备、新药品的研发应用，制定支持境外患者到先行区诊疗的便利化政策。推动文化和旅游融合发展，大力发展动漫游戏、网络文化、数字内容等新兴文化消费，促进传统文化消费升级。允许外资在海南试点设立在本省经营的演出经纪机构，允许外资在海南省内经批准的文化旅游产业集聚区设立演出场所经营单位，演出节目需符合国家法律和政策规定。允许旅游酒店经许可接收国家批准落地的境外电视频道。支持在海南建设国家体育训练南方基地和省级体育中心，鼓励发展沙滩运动、水上运动、赛马运动等项目，支持打造国家体育旅游示范区。探索发展竞猜型体育彩票和大型国际赛事即开彩票。探索从空间规划、土地供给、资源利用等方面支持旅游项目建设。
                </p>
                <p>
                  （十三）提升旅游消费服务质量。鼓励海南旅游企业优化重组，支持符合条件的企业上市融资，促进旅游产业规模化、品牌化、网络化经营，形成一批具有国际竞争力的旅游集团。推进经济型酒店连锁经营，鼓励发展各类生态、文化主题酒店和特色化、中小型家庭旅馆，积极引进国内外高端酒店集团和著名酒店管理品牌。高标准布局建设具有国际影响力的大型消费商圈，完善
                  “互联网+”消费生态体系，鼓励建设 “智能店铺”、
                  “智慧商圈”，支持完善跨境消费服务功能。加强旅游公共服务设施的统筹规划和建设。健全旅游服务的标准体系、监管体系、诚信体系、投诉体系，建立企业信誉等级评价、重大信息公告、消费投诉信息和违规记录公示制度。严厉打击扰乱旅游市场秩序的违法违规行为，完善旅游纠纷调解机制，切实维护旅游者合法权益。支持海南整合旅游营销资源，强化整体宣传营销，促进海南旅游形象提升。
                </p>
                <p>
                  （十四）大力推进旅游消费国际化。支持海南积极引进国际优质资本和智力资源，采用国际先进理念进行旅游资源保护和开发。允许在海南注册的符合条件的中外合资旅行社从事除台湾地区以外的出境旅游业务。支持海南积极参与国际旅游合作与分工，与国际组织和企业在引资引智、市场开发、教育培训、体育赛事等方面开展务实合作。加快建立与国际通行规则相衔接的旅游管理体制，推动更多企业开展国际标准化组织（ISO）质量和环境管理体系认证，提升企业管理水平。系统提升旅游设施和旅游要素的国际化、标准化、信息化水平。指导海南进一步办好国际体育赛事，支持再引入一批国际一流赛事。支持海南举办国际商品博览会和国际电影节。
                </p>
                <p>六、服务和融入国家重大战略</p>
                <p>
                  支持海南履行好党中央赋予的重要使命，持续加强支撑保障能力建设，更好服务海洋强国、
                  “一带一路”建设、军民融合发展等国家重大战略实施。
                </p>
                <p>
                  （十五）加强南海维权和开发服务保障能力建设。加快完善海南的维权、航运、渔业等重点基础设施，显著提升我国对管辖海域的综合管控和开发能力。实施南海保障工程，建立完善的救援保障体系。保障法院行使对我国管辖海域的司法管辖权。支持三亚海上旅游合作开发基地、澄迈等油气勘探生产服务基地建设。加强重点渔港和避风港建设。
                </p>
                <p>
                  （十六）深化对外交往与合作。充分利用博鳌亚洲论坛等国际交流平台，推动海南与
                  “一带一路”沿线国家和地区开展更加务实高效的合作，建设21世纪海上丝绸之路重要战略支点。鼓励境外机构落户海南。支持海南推进总部基地建设，鼓励跨国企业、国内大型企业集团在海南设立国际总部和区域总部。支持在海南设立21世纪海上丝绸之路文化、教育、农业、旅游交流平台，推动琼海农业对外开放合作试验区建设。加强海南与东南亚国家的沟通交流，重点开展旅游、环境保护、海洋渔业、人文交流、创新创业、防灾减灾等领域合作。
                </p>
                <p>
                  （十七）推进军民融合深度发展。落实经济建设项目贯彻国防要求的有关部署，加强军地在基础设施、科技、教育和医疗服务等领域的统筹发展，建立军地共商、科技共兴、设施共建、后勤共保的体制机制，将海南打造成为军民融合发展示范基地。依托海南文昌航天发射场，推动建设海南文昌国际航天城。完善南海岛礁民事服务设施与功能，建设生态岛礁，打造南海军民融合精品工程。深化空域精细化管理改革，提升军民航空域使用效率。完善军地土地置换政策，保障军事用地需求，促进存量土地盘活利用。建设国家战略能源储备基地。
                </p>
                <p>
                  （十八）加强区域合作交流互动。依托泛珠三角区域合作机制，鼓励海南与有关省区共同参与南海保护与开发，共建海洋经济示范区、海洋科技合作区。密切与香港、澳门在海事、海警、渔业、海上搜救等领域的合作，积极对接粤港澳大湾区建设。加强与台湾地区在教育、医疗、现代农业、海洋资源保护与开发等领域的合作。深化琼州海峡合作，推进港航、旅游协同发展。
                </p>
                <p>七、加强和创新社会治理</p>
                <p>
                  始终坚持以人民为中心的发展思想，完善公共服务体系，加强社会治理制度建设，不断满足人民日益增长的美好生活需要，形成有效的社会治理、良好的社会秩序，使人民获得感、幸福感、安全感更加充实、更有保障、更可持续。
                </p>
                <p>
                  （十九）健全改善民生长效机制。坚决打赢精准脱贫攻坚战，建立稳定脱贫长效机制，促进脱贫提质增效。深化户籍制度改革，有序推进农业转移人口市民化，推动基本公共服务覆盖全部常住人口。大力实施基础教育提质工程，全面提升学前教育和中小学教育质量。完善劳动用工制度，健全最低工资标准调整和工资支付保障长效机制。开展激发重点群体增收活力改革试点，推进事业单位改革和人才评价机制改革，在国家政策框架内，加快完善与自由贸易试验区和自由贸易港建设相适应、体现工作绩效和分级分类管理的机关事业单位工资分配政策。创新社会救助模式，完善专项救助制度，在重点保障城乡低保对象、特困人员的基础上，将专项救助向低收入家庭延伸。全面实施全民参保计划。建立和完善房地产长效机制，防止房价大起大落。继续深化医药卫生体制改革。
                </p>
                <p>
                  （二十）打造共建共治共享的社会治理格局。加强预防和化解社会矛盾机制建设，正确处理人民内部矛盾。加强人口动态数据收集分析，建立人口监测预警报告制度。推动建立以社会保障卡为载体的
                  “一卡通”服务管理模式。探索行业协会商会类、科技类、公益慈善类、城乡社区服务类社会组织依法直接登记制度，支持社会组织在规范市场秩序、开展行业监管、加强行业自律、调解贸易纠纷等方面发挥更大作用，推进行业协会商会脱钩改革。全面加强基层治理，统筹推进基层政权建设和基层群众自治，促进乡镇（街道）治理和城乡社区治理有效衔接，构建简约高效的基层管理体制。全面推进社会信用体系建设，加快构建守信激励和失信惩戒机制。围绕行政管理、司法管理、城市管理、环境保护等社会治理的热点难点问题，促进人工智能技术应用，提高社会治理智能化水平。
                </p>
                <p>
                  （二十一）深化行政体制改革。全面贯彻党的十九届三中全会精神，认真落实《中共中央关于深化党和国家机构改革的决定》、《深化党和国家机构改革方案》，坚决维护党中央权威和集中统一领导，率先完成地方党政机构改革。深化
                  “放管服”改革，在进一步简政放权、放管结合、优化服务方面走在全国前列，推动自由贸易试验区和自由贸易港建设。按照宜放则放、不宜放则不放的原则，赋予海南省级政府更多自主权，将贴近基层和群众的管理服务事务交由下级政府承担。推进海南行政区划改革创新，优化行政区划设置和行政区划结构体系。支持海南按照实际需要统筹使用各类编制资源。深化
                  “多规合一”改革，推动形成全省统一的空间规划体系。积极探索与行政体制改革相适应的司法体制改革。
                </p>
                <p>八、加快生态文明体制改革</p>
                <p>
                  牢固树立社会主义生态文明观，像对待生命一样对待生态环境，实行最严格的生态环境保护制度，还自然以宁静、和谐、美丽，提供更多优质生态产品以满足人民日益增长的优美生态环境需要，谱写美丽中国海南篇章。
                </p>
                <p>
                  （二十二）完善生态文明制度体系。加快建立健全生态文明建设长效机制，压紧压实生态环境保护责任。率先建立生态环境和资源保护现代监管体制，设立国有自然资源资产管理和自然生态监管机构。落实环境保护
                  “党政同责、一岗双责”，构建以绿色发展为导向的评价考核体系，严格执行党政领导干部自然资源资产离任审计、生态环境损害责任追究制度。编制自然资源资产负债表，实行省以下环保机构监测监察执法垂直管理制度。支持海南在建立完善自然资源资产产权制度和有偿使用制度方面率先进行探索。加快完善生态保护成效与财政转移支付资金分配相挂钩的生态保护补偿机制。全面实施河长制、湖长制、湾长制、林长制。探索建立水权制度。鼓励海南国家级、省级自然保护区依法合规探索开展森林经营先行先试。加强对海洋生态环境的司法保护。开展海洋生态系统碳汇试点。研究构建绿色标准体系，建立绿色产品政府采购制度，创建绿色发展示范区。实行碳排放总量和能耗增量控制。建立环境污染
                  “黑名单”制度，健全环保信用评价、信息强制性披露、严惩重罚等制度。在环境高风险领域建立环境污染强制责任保险制度。
                </p>
                <p>
                  （二十三）构建国土空间开发保护制度。深入落实主体功能区战略，健全国土空间用途管制制度，完善主体功能区配套政策，制定实施海南省海洋主体功能区规划。完成生态保护红线、永久基本农田、城镇开发边界和海洋生物资源保护线、围填海控制线划定工作，严格自然生态空间用途管制。实行最严格的节约用地制度，实施建设用地总量和强度双控行动，推进城市更新改造，对低效、零散用地进行统筹整合、统一开发，确保海南建设用地总量在现有基础上不增加，人均城镇工矿用地和单位国内生产总值建设用地使用面积稳步下降。加强自然保护区监督管理。研究设立热带雨林等国家公园，构建以国家公园为主体的自然保护地体系，按照自然生态系统整体性、系统性及其内在规律实行整体保护、系统修复、综合治理。实施重要生态系统保护和修复重大工程，构建生态廊道和生物多样性保护网络，提升生态系统质量和稳定性。鼓励在重点生态区位推行商品林赎买制度，探索通过租赁、置换、地役权合同等方式规范流转集体土地和经济林，逐步恢复和扩大热带雨林等自然生态空间。实施国家储备林质量精准提升工程，建设乡土珍稀树种木材储备基地。对生态环境脆弱和敏感区域内居民逐步实施生态移民搬迁。严格保护海洋生态环境，更加重视以海定陆，加快建立重点海域入海污染物总量控制制度，制定实施海岸带保护与利用综合规划。
                </p>
                <p>
                  （二十四）推动形成绿色生产生活方式。坚持
                  “绿色、循环、低碳”理念，建立产业准入负面清单制度，全面禁止高能耗、高污染、高排放产业和低端制造业发展，推动现有制造业向智能化、绿色化和服务型转变，加快构建绿色产业体系。实施能源消费总量和强度双控行动。支持海南建设生态循环农业示范省，加快创建农业绿色发展先行区。实行生产者责任延伸制度，推动生产企业切实落实废弃产品回收责任。减少煤炭等化石能源消耗，加快构建安全、绿色、集约、高效的清洁能源供应体系。建立闲置房屋盘活利用机制，鼓励发展度假民宿等新型租赁业态。探索共享经济发展新模式，在出行、教育、职业培训等领域开展试点示范。科学合理控制机动车保有量，加快推广新能源汽车和节能环保汽车，在海南岛逐步禁止销售燃油汽车。全面禁止在海南生产、销售和使用一次性不可降解塑料袋、塑料餐具，加快推进快递业绿色包装应用。
                </p>
                <p>九、完善人才发展制度</p>
                <p>
                  实施人才强国战略，深化人才发展体制机制改革，实行更加积极、更加开放、更加有效的人才政策，加快形成人人渴望成才、人人努力成才、人人皆可成才、人人尽展其才的良好环境。
                </p>
                <p>
                  （二十五）创新人才培养支持机制。鼓励海南充分利用国内外优质教育培训资源，加强教育培训合作，培养高水平的国际化人才。支持海南大学创建世界一流学科，支持相关高校培育建设重点实验室。鼓励国内知名高校和研究机构在海南设立分支机构。完善职业教育和培训体系，深化产教融合、校企合作，鼓励社会力量通过独资、合资、合作等多种形式举办职业教育。鼓励海南引进境外优质教育资源，举办高水平中外合作办学机构和项目，探索建立本科以上层次中外合作办学项目部省联合审批机制。支持海南通过市场化方式设立专业人才培养专项基金。完善促进终身教育培训的体制机制。
                </p>
                <p>
                  （二十六）构建更加开放的引才机制。加大国家级人才计划对海南省人才队伍建设的支持力度。紧紧围绕强化公益属性的目标深化事业单位改革，除仅为机关提供支持保障的事业单位外，原则上取消行政级别，允许改革后的事业单位结合实际完善有利于激励人才的绩效工资内部分配办法。促进教师、医生、科研人员等合理流动。创新
                  “候鸟型”人才引进和使用机制，设立
                  “候鸟”人才工作站，允许内地国企、事业单位的专业技术和管理人才按规定在海南兼职兼薪、按劳取酬。支持海南开展国际人才管理改革试点，允许外籍和港澳台地区技术技能人员按规定在海南就业、永久居留。允许在中国高校获得硕士及以上学位的优秀外国留学生在海南就业和创业，扩大海南高校留学生规模。支持海南探索建立吸引外国高科技人才的管理制度。
                </p>
                <p>
                  （二十七）建设高素质专业化干部队伍。坚持党管干部原则，坚持正确选人用人导向，突出政治标准，注重培养专业能力、专业精神，增强干部队伍助推海南全面深化改革开放的能力。推进公务员聘任制和分类管理改革，拓宽社会优秀人才进入党政干部队伍渠道，允许在专业性较强的政府机构设置高端特聘职位，实施聘期管理和协议工资。加强海南与国内发达地区的公务员学习交流，开展公务员国际交流合作，稳妥有序开展公务人员境外培训。加强优秀后备干部储备，完善鼓励干部到基层一线、困难艰苦地区历练的机制。
                </p>
                <p>
                  （二十八）全面提升人才服务水平。加大优质公共服务供给，满足人才对高品质公共服务的需求。大力引进优质医疗资源，鼓励社会力量发展高水平医疗机构，推进国际国内医疗资源合作，积极引进优秀卫生专业技术人员。深度推进跨省异地就医住院医疗费用直接结算，鼓励发展商业补充保险。推进社会养老服务设施建设。加快数字图书馆、数字博物馆、网上剧院等建设，构建标准统一、互联互通的公共数字文化服务网络。出台专门政策解决引进人才的任职、住房、就医、社保、子女教育等问题。
                </p>
                <p>十、保障措施</p>
                <p>
                  毫不动摇加强党对改革开放的领导，进一步强化政策支持，建立健全
                  “中央统筹、部门支持、省抓落实”的工作机制，坚定自觉地把党中央、国务院的决策部署落到实处。
                </p>
                <p>
                  （二十九）加强党的领导。坚持党对一切工作的领导，充分发挥党总揽全局、协调各方的作用。海南省委要把党的政治建设摆在首位，用习近平新时代中国特色社会主义思想武装海南党员干部。着眼于健全加强党的全面领导的制度，优化党的组织机构，建立健全省委对全面深化改革开放工作的领导体制机制，更好发挥党的职能部门作用，提高党把方向、谋大局、定政策、促改革的能力和定力。加强基层党组织建设，着力提升组织力，增强政治功能，引导广大党员发挥先锋模范作用，把基层党组织建设成为推动海南全面深化改革开放的坚强战斗堡垒。完善体现新发展理念和正确政绩观要求的干部考核评价体系，建立激励机制和容错纠错机制，旗帜鲜明地为敢于担当、踏实做事、不谋私利的干部撑腰鼓劲。牢牢掌握意识形态工作领导权，把社会主义核心价值观融入社会发展各方面，坚定文化自信。持之以恒正风肃纪，强化纪检监察工作，营造风清气正良好环境。深化政治巡视。全面落实监察法。
                </p>
                <p>
                  （三十）强化政策保障。本意见提出的各项改革政策措施，凡涉及调整现行法律或行政法规的，经全国人大或国务院统一授权后实施。中央有关部门根据海南省建设自由贸易试验区、探索实行符合海南发展定位的自由贸易港政策需要，及时向海南省下放相关管理权限，给予充分的改革自主权。按照市场化方式，设立海南自由贸易港建设投资基金。深化司法体制综合配套改革，全面落实司法责任制，实行法院、检察院内设机构改革试点，建立法官、检察官员额退出机制。支持建立国际经济贸易仲裁机构和国际争端调解机构等多元纠纷解决机构。
                </p>
                <p>
                  （三十一）完善实施机制。海南省要发挥主体责任，主动作为、真抓实干，敢为人先、大胆探索，以
                  “功成不必在我”的精神境界和
                  “功成必定有我”的历史担当，一任接着一任干，一茬接着一茬干，将蓝图一绘到底。要制定预案，稳定市场预期，坚决防范炒房炒地投机行为。研究建立重大问题协调机制，统筹推进海南全面深化改革开放工作。中央有关部门要真放真改真支持，切实贯彻落实本意见提出的各项任务和政策措施，会同海南省抓紧制定实施方案。国家发展改革委要加强综合协调，强化督促检查，适时组织对本意见实施情况进行评估，及时发现问题并提出整改建议，重大事项向党中央、国务院报告。
                </p>
              </div>
            </el-scrollbar>
          </el-tab-pane>
          <el-tab-pane label="中国（海南）自由贸易试验区总体方案" name="second">
            <el-scrollbar tag="section">
              <div>
                <p>
                  赋予海南经济特区改革开放新的使命，是习近平总书记亲自谋划、亲自部署、亲自推动的重大国家战略。建设中国（海南）自由贸易试验区（以下简称自贸试验区）是党中央、国务院着眼于国际国内发展大局，深入研究、统筹考虑、科学谋划作出的重大决策，是彰显我国扩大对外开放、积极推动经济全球化决心的重大举措。为深入贯彻习近平总书记在庆祝海南建省办经济特区30周年大会上的重要讲话精神，落实《中共中央
                  国务院关于支持海南全面深化改革开放的指导意见》要求，高标准高质量建设自贸试验区，制定本方案。
                </p>
                <p>一、总体要求</p>
                <p>
                  （一）指导思想。高举中国特色社会主义伟大旗帜，全面贯彻党的十九大和十九届二中、三中全会精神，以习近平新时代中国特色社会主义思想为指导，坚持和加强党的全面领导，坚持以人民为中心的发展思想，坚持稳中求进工作总基调，坚持新发展理念，坚持高质量发展，统筹推进“五位一体”总体布局和协调推进“四个全面”战略布局，以供给侧结构性改革为主线，解放思想、大胆创新，坚持开放为先，以制度创新为核心，赋予更大改革自主权，大胆试、大胆闯、自主改，深化简政放权、放管结合、优化服务改革，加快形成法治化、国际化、便利化的营商环境和公平开放统一高效的市场环境，将生态文明理念贯穿自贸试验区建设全过程，积极探索自贸试验区生态绿色发展新模式，加强改革系统集成，力争取得更多制度创新成果，彰显全面深化改革和扩大开放试验田作用。
                </p>
                <p>
                  （二）战略定位。发挥海南岛全岛试点的整体优势，紧紧围绕建设全面深化改革开放试验区、国家生态文明试验区、国际旅游消费中心和国家重大战略服务保障区，实行更加积极主动的开放战略，加快构建开放型经济新体制，推动形成全面开放新格局，把海南打造成为我国面向太平洋和印度洋的重要对外开放门户。
                </p>
                <p>
                  （三）发展目标。对标国际先进规则，持续深化改革探索，以高水平开放推动高质量发展，加快建立开放型生态型服务型产业体系。到2020年，自贸试验区建设取得重要进展，国际开放度显著提高，努力建成投资贸易便利、法治环境规范、金融服务完善、监管安全高效、生态环境质量一流、辐射带动作用突出的高标准高质量自贸试验区，为逐步探索、稳步推进海南自由贸易港建设，分步骤、分阶段建立自由贸易港政策体系打好坚实基础。
                </p>
                <p>二、在海南全岛建设自由贸易试验区</p>
                <p>
                  （四）实施范围。自贸试验区的实施范围为海南岛全岛。自贸试验区土地、海域开发利用须遵守国家法律法规，贯彻生态文明和绿色发展要求，符合海南省“多规合一”总体规划，并符合节约集约用地用海的有关要求。涉及无居民海岛的，须符合《中华人民共和国海岛保护法》有关规定。
                </p>
                <p>
                  （五）功能划分。按照海南省总体规划的要求，以发展旅游业、现代服务业、高新技术产业为主导，科学安排海南岛产业布局。按发展需要增设海关特殊监管区域，在海关特殊监管区域开展以投资贸易自由化便利化为主要内容的制度创新，主要开展国际投资贸易、保税物流、保税维修等业务。在三亚选址增设海关监管隔离区域，开展全球动植物种质资源引进和中转等业务。
                </p>
                <p>三、加快构建开放型经济新体制</p>
                <p>
                  （六）大幅放宽外资市场准入。对外资全面实行准入前国民待遇加负面清单管理制度。深化现代农业、高新技术产业、现代服务业对外开放，在种业、医疗、教育、旅游、电信、互联网、文化、金融、航空、海洋经济、新能源汽车制造等重点领域加大开放力度。取消蔬菜新品种选育和种子生产外资股比限制。将增值电信业务外资准入审批权下放给海南省，取消国内多方通信服务业务、上网用户互联网接入服务业务、存储转发类业务外资股比限制，允许外商投资国内互联网虚拟专用网业务（外资股比不超过50%）。允许设立外商投资文艺表演团体（中方控股）。放宽人身险公司外资股比限制至51%。取消船舶（含分段）及干线、支线、通用飞机设计、制造与维修外资股比限制。取消石油天然气勘探开发须通过与中国政府批准的具有对外合作专营权的油气公司签署产品分成合同方式进行的要求。取消国际海上运输公司、国际船舶代理公司外资股比限制。允许在自贸试验区内设立的外商独资建筑业企业承揽区内建筑工程项目，不受项目双方投资比例限制。允许取得我国一级注册建筑师或一级注册结构工程师资格的境外专业人士作为合伙人，按相应资质标准要求设立建筑工程设计事务所。取消新能源汽车制造外资准入限制。
                </p>
                <p>
                  （七）提升贸易便利化水平。对进出海南洋浦保税港区的货物，除禁止进出口和限制出口以及需要检验检疫的货物外，试行“一线放开、二线高效管住”的货物进出境管理制度。加快建设具有国际先进水平的国际贸易“单一窗口”，推动数据协同、简化和标准化，实现物流和监管等信息的全流程采集，实现监管单位的信息互换、监管互认、执法互助。以口岸管理部门的通关物流状态信息为基础，整合作业信息，形成完整的通关物流状态综合信息库，为企业提供全程数据服务。加强口岸管理部门执法合作，推行跨部门一次性联合检查。实施海事、交通、船检三部门船舶证书信息共享。积极推进货物平均放行和结关时间体系化建设，构建规范的测算标准和透明的公布机制。扩大第三方检验结果采信商品和机构范围。依照自由贸易协定安排，推动实施原产地自主声明制度和原产地预裁定制度。拓展暂时进口货物单证制度适用范围，延长单证册的有效期。平行进口汽车企业可以使用价格预裁定、汇总征税等通关便利化措施。创新出口货物专利纠纷担保放行方式。支持开展海关税款保证保险试点。简化野生动植物出口许可程序。
                </p>
                <p>
                  （八）创新贸易综合监管模式。研究赋予海关特殊监管区域内企业增值税一般纳税人资格，在海关特殊监管区域全面实施货物状态分类监管。研究支持对海关特殊监管区域外“两头在外”航空维修业态实行保税监管。在风险可控前提下，创新维修监管模式，开展外籍邮轮船舶维修业务。完善进口商品风险预警快速反应机制，加强安全风险监测，实施安全问题调查制度。建设重要产品进出口安全追溯体系，实现重点敏感产品全过程信息可追溯，与国家重要产品追溯平台对接，实现信息共享。对优质农产品出口免于出具检验检疫证书和备案。优化生物医药全球协同研发的试验用特殊物品的检疫查验流程。完善国际邮件互换局（交换站）布局，加强国际快件监管中心建设，打造重要跨境电商寄递中心。支持在海关特殊监管区域和保税监管场所设立大宗商品期货保税交割库。
                </p>
                <p>
                  （九）推动贸易转型升级。培育贸易新业态新模式，支持发展跨境电商、全球维修等业态。探索建立跨境服务贸易负面清单管理制度。支持海南享受服务外包示范城市政策，建立特色服务出口基地。支持海南设立跨境电子商务综合试验区，完善和提升海关监管、金融、物流等支持体系。支持跨境电商企业建设覆盖重点国别、重点市场的海外仓。支持开展跨境电商零售进口网购保税。支持在海关特殊监管区域设立国际文化艺术品交易场所，依法合规开展面向全球的保税文化艺术品展示、拍卖、交易业务。试点实施进口非特殊用途化妆品备案管理。支持开展橡胶等大宗商品现货离岸交易和保税交割业务。支持跨国公司、贸易公司建立和发展全球或区域贸易网络，打造区域性离岸贸易中心。支持具备资质的供油企业开展国际航行船舶保税油供应业务，建设保税油供应基地。将国际快递业务经营许可审批权下放到海南省邮政管理局。
                </p>
                <p>
                  （十）加快金融开放创新。充分发挥金融支持自贸试验区建设的重要作用，出台金融领域的一揽子政策措施，以服务实体经济、促进贸易投融资便利化为出发点和落脚点，以制度创新为核心，大力推动自贸试验区金融开放创新。进一步扩大人民币跨境使用、探索资本项目可兑换、深化外汇管理改革、探索投融资汇兑便利化，扩大金融业开放，为贸易投资便利化提供优质金融服务。
                </p>
                <p>
                  （十一）加强“一带一路”国际合作。按照“共商、共建、共享”的原则，构筑全方位立体化开放通道。鼓励“一带一路”国家和地区参与自贸试验区建设。支持“一带一路”国家在海南设立领事机构。支持与“一带一路”国家开展科技人文交流、共建联合实验室、科技园区合作、技术转移等科技创新合作。推动海口、三亚与“一带一路”国家和地区扩大包括第五航权在内的航权安排，提高机场航班保障能力，吸引相关国家和地区航空公司开辟经停海南的航线。与“一带一路”国家和地区自由贸易园区在投资、贸易、金融、教育等方面开展交流合作与功能对接。
                </p>
                <p>四、加快服务业创新发展</p>
                <p>
                  （十二）推动现代服务业集聚发展。依托博鳌乐城国际医疗旅游先行区，大力发展国际医疗旅游和高端医疗服务，对先行区范围内确需进口的、关税税率较高的部分医疗器械研究适当降低关税。支持开展干细胞临床前沿医疗技术研究项目。依托现有医药产业基础，探索开展重大新药创制国家科技重大专项成果转移转化试点。鼓励中外航空公司新开或加密海南直达全球主要客源地的国际航线。支持举办国际商品博览会、国际电影节、中国（海南）国际海洋产业博览会等大型国际展览会、节庆活动，以及文化旅游、国际品牌等适合海南产业特点的展会。优化国际会议、赛事、展览监管，进一步简化展品检疫审批管理。支持引进国际化的规划、建筑工程、建筑设计、仲裁、会计、知识产权、医疗健康、影视、会展等专业服务机构，推进服务要素集聚。授权自贸试验区制定港澳专业人才执业管理办法，允许具有港澳执业资格的金融、建筑、规划、专利代理等服务领域专业人才经备案后为自贸试验区内企业提供专业服务。支持海南开展供应链创新与应用试点。打造联通国际国内的全球性商贸物流节点，促进港口、机场、铁路车站、物流园区等物流信息互通。加强冷链基础设施网络建设，打造出岛快速冷链通道，提供高质量的冷链快递物流服务。在交通运输领域完善快件处理设施和绿色通道，提高国际快递处理能力，服务带动跨境电商等相关产业集聚。建设以天然橡胶为主的国际热带农产品交易中心、定价中心、价格指数发布中心。设立热带农产品拍卖中心。支持完善跨境消费服务功能。高标准建设商务诚信示范省。
                </p>
                <p>
                  （十三）提升国际航运能力。依托自贸试验区，科学有序开发利用海洋资源，培育壮大特色海洋经济，建设南海服务保障基地。建设具有较强服务功能和辐射能力的国际航运枢纽，不断提高全球航运资源配置能力。大力引进国内外航运企业在自贸试验区设立区域总部或营运中心，促进航运要素集聚。积极培育壮大外轮供应企业，丰富外轮供应品种，为进入自贸试验区的船舶提供生活用品、备品备件、物料、工程服务和代理服务等。利用现有方便旗船税收政策，促进符合条件的船舶在自贸试验区落户登记。扩大内外贸同船运输、国轮捎带运输适用范围，提升运力资源综合效能。支持境内外企业和机构开展航运保险、航运仲裁、海损理算、航运交易、船舶融资租赁等高端航运服务，打造现代国际航运服务平台。支持设立专业化地方法人航运保险机构。培育发展专业化第三方船舶管理公司。逐步开放中国籍国际航行船舶入级检验。将无船承运、外资经营国际船舶管理业务行政许可权下放给海南省。
                </p>
                <p>
                  （十四）提升高端旅游服务能力。发展环海南岛邮轮航线，支持邮轮企业根据市场需求依法拓展东南亚等地区邮轮航线，不断丰富由海南邮轮港口始发的邮轮航线产品。研究支持三亚等邮轮港口参与中资方便旗邮轮公海游试点，将海南纳入国际旅游“一程多站”航线。积极支持实施外国旅游团乘坐邮轮15天入境免签政策。优化对邮轮和邮轮旅客的检疫监管模式。建设邮轮旅游岸上国际配送中心，创建与国际配送业务相适应的检验、检疫、验放等海关监管制度。简化游艇入境手续。允许海南对境外游艇开展临时开放水域审批试点。实施琼港澳游艇自由行。建设一流的国际旅行卫生保健中心，为出入境人员提供高质量的国际旅行医疗服务。加强旅游行业信用体系建设。
                </p>
                <p>
                  （十五）加大科技国际合作力度。创建南繁育种科技开放发展平台。划定特定区域，通过指定口岸管辖和加强生物安全管理，建设全球动植物种质资源引进中转基地，探索建立中转隔离基地（保护区）、检疫中心、种质保存中心、种源交易中心。推进农业对外合作科技支撑与人才培训基地建设。引进国际深远海领域科研机构、高校等前沿科技资源，打造国际一流的深海科技创新平台。搭建航天科技开发开放平台，推动商用航天发展和航天国际合作。
                </p>
                <p>五、加快政府职能转变</p>
                <p>
                  （十六）深化机构和行政体制改革。赋予海南省人民政府更多自主权，科学配置行政资源，大力转变政府职能，深化“放管服”改革。探索建立与自贸试验区建设相适应的行政管理体制。支持自贸试验区探索按照实际需要加大同类编制资源的统筹使用。深化完善综合行政执法体制改革。实行包容审慎监管，提高执法效能。
                </p>
                <p>
                  （十七）打造国际一流营商环境。借鉴国际经验，开展营商环境评价，在开办企业、办理施工许可证、获得电力、登记财产、获得信贷、保护少数投资者、纳税、跨境贸易、执行合同和办理破产等方面加大改革力度。推动准入前和准入后管理措施的有效衔接，实施公平竞争审查制度，实现各类市场主体依法平等准入相关行业、领域和业务。加快推行“证照分离”改革，全面推进“多证合一”改革。简化外商投资企业设立程序，全面实行外商投资企业商务备案与工商登记“一口办理”。探索建立普通注销登记制度和简易注销登记制度相互配套的市场主体退出制度。
                </p>
                <p>
                  （十八）深入推进行政管理职能与流程优化。全面推进行政审批和行政服务标准化。调整完善省级管理权限下放，推动关联、相近类别审批事项全链条取消、下放或委托。海南省人民政府报国务院批准土地征收事项由国务院授权海南省人民政府批准。推行“极简审批”改革。精简投资项目准入手续，探索实施先建后验管理新模式。实行建设项目联合验收，实现“一口受理”、“两验终验”，推行“函证结合”、“容缺后补”等改革。清理规范基层证明，对暂不宜取消的实行清单管理。
                </p>
                <p>
                  （十九）全面推行“互联网+政务服务”模式。整合资源与数据，加快构建一体化互联网政务服务平台。涉及企业注册登记、年度报告、项目投资、生产经营、商标专利、资质认定、税费办理、安全生产等方面的政务服务事项，最大限度实行网上受理、网上办理、网上反馈。实施全程电子化登记和电子营业执照管理。围绕行政管理、司法管理、城市管理、环境保护等社会治理的热点难点问题，促进人工智能技术应用，提高社会治理智能化水平。
                </p>
                <p>
                  （二十）完善知识产权保护和运用体系。推进知识产权综合执法，建立跨部门、跨区域的知识产权案件移送、信息通报、配合调查等机制。支持建立知识产权交易中心，推动知识产权运营服务体系建设。建立包含行政执法、仲裁、调解在内的多元化知识产权争端解决与维权援助机制，探索建立重点产业、重点领域知识产权快速维权机制。探索建立自贸试验区专业市场知识产权保护工作机制，完善流通领域知识产权保护体系。探索建立公允的知识产权评估机制，完善知识产权质押登记制度、知识产权质押融资风险分担机制以及方便快捷的质物处置机制，为扩大以知识产权质押为基础的融资提供支持。鼓励探索知识产权证券化，完善知识产权交易体系与交易机制。深化完善有利于激励创新的知识产权归属制度。搭建便利化的知识产权公共服务平台，设立知识产权服务工作站，大力发展知识产权专业服务业。
                </p>
                <p>
                  （二十一）提高外国人才工作便利度。为在自贸试验区工作和创业的外国人才提供出入境、居留和永久居留便利。支持开展国际人才管理改革试点，允许外籍技术技能人员按规定在自贸试验区工作。探索建立与国际接轨的全球人才招聘制度和吸引外国高技术人才的管理制度。开辟外国人才绿色通道，深入实施外国人来华工作许可制度。开展外国高端人才服务“一卡通”试点，建立住房、子女入学、就医社保服务通道。
                </p>
                <p>六、加强重大风险防控体系和机制建设</p>
                <p>
                  （二十二）建立健全事中事后监管制度。以风险防控为底线，维护国家安全和社会安全。外商在自贸试验区内投资适用《自由贸易试验区外商投资国家安全审查试行办法》。自贸试验区要建立健全以信用监管为核心、与负面清单管理方式相适应的事中事后监管体系。配合做好国家安全审查、反垄断审查等相关工作。制定重大风险防控规划和制度，建立应急响应机制，协调解决风险防控中的重大问题。完善社会信用体系，加强信用信息归集共享，推行企业信息公示，健全守信激励和失信惩戒机制。推动各部门间依法履职信息联通共享。建立大数据高效监管模式，加强风险监测分析，建立完善信用风险分类监管。
                </p>
                <p>
                  （二十三）建立健全贸易风险防控体系。优化海关监管方式，强化进出境安全准入管理，完善对国家禁止和限制入境货物、物品的监管，精准高效打击走私活动。全面落实联合缉私和统一处理、综合治理的缉私体制。构建自贸试验区进出境安全风险信息平台。确保进出口货物的交易真实、合法，防范不法企业借助货物进出口的便利化措施从事非法融资、非法跨境资金转移等违法活动。
                </p>
                <p>
                  （二十四）建立健全金融风险防控体系。打好防范化解重大风险攻坚战，有效履行属地金融监管职责，建立区域金融监管协调机制，加强对重大风险的识别和对系统性金融风险的防范，严厉打击洗钱、恐怖融资、逃税等金融违法犯罪活动，有效防范金融风险。
                </p>
                <p>
                  （二十五）加强口岸风险防控。进一步提升口岸核心能力建设，提高口岸传染病防控水平。坚决防范对外经贸往来中的生态环境风险，严格引进种质资源的隔离与监管，严格野生动植物进口管理，防止生物入侵对海岛生态环境的破坏。加强口岸动植物疫病疫情监测，形成多部门协作的疫病疫情和有害生物联防联控局面。完善人员信息采集管控体系，加强对出入境核生化等涉恐材料检查力度。
                </p>
                <p>七、坚持和加强党对自贸试验区建设的全面领导</p>
                <p>
                  （二十六）加强党的领导。坚持和加强党对改革开放的领导。把党的领导贯穿于自贸试验区建设的全过程，增强“四个意识”，坚定“四个自信”，自觉维护以习近平同志为核心的党中央权威和集中统一领导，培育践行社会主义核心价值观，确保改革开放的社会主义方向，营造风清气正的良好政治生态。海南省要用习近平新时代中国特色社会主义思想指导改革开放，坚持全面从严治党，把党的政治建设摆在首位，坚决反对腐败、反对“四风”。
                </p>
                <p>
                  （二十七）强化法制保障。本方案提出的各项改革政策措施，凡涉及调整现行法律或行政法规的，经全国人大及其常委会或国务院统一授权后实施。各有关部门要支持自贸试验区在各领域深化改革开放试点、加大压力测试、加强监管、防控风险，做好与相关法律法规立改废释的衔接，及时解决试点过程中的制度保障问题。海南省要加强经济特区立法，建立与试点要求相适应的管理制度，建立公正透明、体系完备的法制环境。
                </p>
                <p>
                  （二十八）完善配套政策。完善人才发展制度，建设高素质专业化干部队伍，全面提升人才服务水平。加大对水利、港口、机场、公路、铁路、综合枢纽等重大基础设施建设的支持力度。落实现有相关税收政策，充分发挥现有政策的支持促进作用。在其他自由贸易试验区已经试点可复制的税收政策均可在海南自贸试验区进行试点，其中促进贸易的选择性征收关税、其他相关进出口税收等政策在自贸试验区内的海关特殊监管区域进行试点。自贸试验区内的海关特殊监管区域的实施范围和税收政策适用范围维持不变。加快完善军地土地置换政策。
                </p>
                <p>
                  （二十九）加强组织实施。按照党中央、国务院统一部署，在国务院自由贸易试验区工作部际联席会议统筹协调下，由海南省完善试点任务组织实施保障机制，按照总体筹划、分步实施、率先突破、逐步完善的原则，扎扎实实推进各项工作。其他自由贸易试验区施行的政策，凡符合海南发展定位的，海南省均可按程序报批后在自贸试验区进行试点。各有关部门要根据海南建设自贸试验区需要，及时向海南省下放相关管理权限，给予充分的改革自主权，同时加强指导和服务，共同推进相关体制机制创新。自贸试验区建设要更好服务和融入“一带一路”建设、海洋强国、军民融合发展等国家重大战略。要以防控风险为底线，建立健全全面风险管理体系和机制，完善风险防控和处置机制，出台有关政策时，要深入论证、严格把关，成熟一项，推出一项，实现区域稳定安全高效运行。要坚持高标准高质量建设自贸试验区，落实好各项改革试点任务，真正把自贸试验区建设成为全面深化改革开放的新高地。重大事项及时向党中央、国务院请示报告。
                </p>
              </div>
            </el-scrollbar>
          </el-tab-pane>
        </el-tabs>
      </el-dialog>
      <el-footer height="260px">
        <v-footer></v-footer>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import header from '@/publicResource/components/header.vue'
import footer from '@/publicResource/components/footer.vue'
import logintab from '@/module/index/components/loginTab.vue'
// import {searchLaws} from '@/publicResource/api/api.js'
import topbar from '@/publicResource/components/topbar.vue'
// import axios from 'axios'
import {
  getPCHomeDataCount,
  logoutOptions
} from '@/publicResource/api/apiSetting.js'
import robot from '@/publicResource/config/robot'
import {
  getStore,
  removeStore,
  setStore
} from '@/publicResource/utils/utils.js'
import {
  getGongdaoLoginToken,
  gongdaoLoginSkip
} from '@/publicResource/api/apiUser.js'
// import config from '@/publicResource/config/config.js'

export default {
  data () {
    return {
      showMes: false,
      countList2: [],
      dialogTableVisiblePeoTime: false,
      dialogTableVisiblePeoNoTime: false,
      dialogTableVisibleFta: false, // 自贸区
      activeName: 'first',
      isContent: [true, false, false],
      isshowapplet: false,
      islogin: false,
      countList: [],
      mobilephone: '',
      userSex: '',
      courtNumber: '', // 法院
      headUrl: '',
      organizationNumber: '', // 调解机构
      mediatorNumber: '', // 调解员
      isRealName: false,
      robot: robot,
      isCustomer: true, // 人工咨询是否游客
      logininfos: null,
      isShowCard: false,
      isShowAll: false,
      isup: false,
      iACount: '',
      currTab: 0,
      mediateCount: '',
      firstNews: {
        id: 'Z8c6rmUBJp0hsCmOhIdf',
        title: '海南省旅游条例',
        simpleContent:
          '为保障旅游者、旅游经营者及其从业人员的合法权益，保护和合理利用旅游资源，规范旅游市场秩序，推进海南国际旅游岛建设，促进旅游业持续健康发展，根据《中华人民共和国旅游法》及有关法律、法规，结合本省实际，制定本条例',
        publishDate: '2014-06-26'
      },
      secondNews: [
        {
          id: 'tMc6rmUBJp0hsCmOhIdf',
          title:
            '海南省人民代表大会常务委员会关于修改《海南经济特区安全生产条例》的决定　附：修正本',
          publishDate: '2016-11-30'
        },
        {
          id: 'U8c6rmUBJp0hsCmOhIZf',
          title: '海南省人民政府关于废止《海南省收容遣送规定》的决定',
          publishDate: '2003-09-10'
        },
        {
          id: 'Tsc6rmUBJp0hsCmOID-9',
          title: '国务院关于鼓励投资开发海南岛的规定',
          publishDate: '1998-05-04'
        },
        {
          id: 'S8c6rmUBJp0hsCmOID-9',
          title: '外国籍非军用船舶通过琼州海峡管理规则',
          publishDate: '1964-06-08'
        }
      ],
      secondNews1: {
        id: '78c6rmUBJp0hsCmOhIdf',
        title: '海南经济特区股份合作企业条例',
        simpleContent:
          '为鼓励、引导和促进股份合作企业的发展，规范其组织和行为，维护企业、企业投资者和劳动者的合法权益，调动企业职工的积极性，根据有关法律、法规的原则，结合本经济特区实际，制定本条例。',
        publishDate: '1997-08-25'
      },
      thirdNews: [
        {
          id: '7sc6rmUBJp0hsCmOhIZf',
          title: '海南国际旅游岛建设发展条例',
          publishDate: '2011-01-14'
        },
        {
          id: 'hcc6rmUBJp0hsCmOhIdf',
          title: '海南省社会救助规定',
          publishDate: '2015-11-17'
        },
        {
          id: 'o8c6rmUBJp0hsCmOhIZf',
          title: '海南省非税收入管理办法',
          publishDate: '2006-05-12'
        },
        {
          id: 'CMc6rmUBJp0hsCmOhIdf',
          title:
            '海南省人民政府关于废止《海南省城市市容和环境卫生管理办法》和《海南省邮政管理规定》的决定',
          publishDate: '2012-04-06'
        }
      ],
      locale: ''
    }
  },
  components: {
    'v-header': header,
    'v-footer': footer,
    logintab: logintab,
    'v-topbar': topbar
  },
  filters: {
    formatToMoney (val) {
      return `${`${parseInt(val)}`.replace(
        /\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,
        '$&,'
      )}`
    }
  },
  mounted () {
    this.locale = localStorage.getItem('locale')
    // 是否为公道跳转登录
    let ct = getStore('loginCurrTab')
    if (ct === 1) {
      this.currTab = 1
    }
    // let flag =
    //   document.referrer ==
    //   "https://www.gzinternetcourt.gov.cn/portal/main/domain/index.htm";
    removeStore('loginCurrTab')
    const url = window.location.href
    const states = url.split('&')
    const logout = url.split('=')
    if (logout.length === 2) {
      const logoutFlag = logout[1]
      if (logoutFlag === 'true') {
        logoutOptions().then(
          res => {
            removeStore('authToken')
            removeStore('refreshToken')
            removeStore('loginInfouser')
            removeStore('dddddd')

            this.islogin = false
          },
          erro => {
            this.$message.error(erro)
          }
        )
      }
    }
    if (states.length >= 2) {
      this.getlogin()
    }
    this.hasLogined()
    getPCHomeDataCount().then(
      res => {
        if (res.data.code === 1000) {
          this.countList = res.data.data.slice(0, 2)
          this.iACount = String(this.countList[1].resourceNumber).split('')
          this.mediateCount = String(this.countList[0].resourceNumber).split('')
          this.countList2 = res.data.data.filter((ele, index) => {
            if (index === 0 || index === 2 || index === 3) {
              return ele
            }
          })
          this.countList2[0] = {
            resourceName: this.$t('header.lawsAndRegulations'),
            resourceNumber: res.data.data[5].resourceNumber
          }
          this.countList2[1] = {
            resourceName: this.$t('header.caseLibrary'),
            resourceNumber: res.data.data[6].resourceNumber
          }
          this.countList2[2] = res.data.data[2]
          this.countList2[3] = res.data.data[3]
          // this.countList2 = (res.data.data.slice(2,3)).push(res.data.data[0]);
        }
      },
      err => {}
    )
    //      getCountMediation(data).then((res) => {
    //          console.log(res)
    //          if (res.data.code === 1000) {
    //              this.iACount = String(res.data.data.intelligentAllCount).split('')
    //              this.mediateCount = String(res.data.data.mediateTotalNumber).split('')
    //              console.log(this.iACount)
    //              console.log(this.mediateCount)
    //          }
    //      }, (err) => {
    //
    //      });
    // axios.post('https://lawsearch-pre.odrcloud.cn/search/ftls/searchLaws', {
    //   'keywords': ['粤港澳'],
    //   'size': 9,
    //   'start': 0,
    //   'sortField': '_score',
    //   'order': 'desc'
    // }).then((res) => {
    //   if (res.data.code === 1000) {
    //     let data = []
    //     for (let index in res.data.data.data) {
    //       data.push({
    //         title: res.data.data.data[index].title.replace(/<em>/g, '').replace(/<\/em>/g, ''),
    //         simpleContent: res.data.data.data[index].simpleContent.replace(/<em>/g, '').replace(/<\/em>/g, ''),
    //         publishDate: res.data.data.data[index].publishDate,
    //         id: res.data.data.data[index].id
    //       })
    //     }
    //     // this.firstNews = data.slice(0, 1)[0]
    //     // this.secondNews1 = data.slice(1, 5)[0]
    //     // this.secondNews = data.slice(1, 5)
    //     // this.thirdNews = data.slice(5)
    //   }
    // })
  },
  methods: {
    moreLaw () {
      let currentLa = localStorage.getItem('locale')
      if (currentLa === 'en_US') {
        currentLa = 'en'
      } else if (currentLa === 'zh_TW') {
        currentLa = 'tc'
      } else {
        currentLa = 'zh'
      }
      // window.open(config.searchCaseUrl + '/?lang=' + currentLa + '#/')
      window.open('https://law.odrcloud.cn/gd-fa/index')
    },
    openNewTab (type) {
      let url = ''
      switch (type) {
        case 0:
          url = '../../../static/pages/dist4/opinions.html'
          break
        case 1:
          url = '../../../static/pages/dist4/free.html'
          break
        case 2:
          url = '../../../static/pages/dist4/tourismRegulations.html'
          break
      }
      window.open(url)
    },
    ContentIn (num) {
      for (let i = 0; i < this.isContent.length; i++) {
        if (num === i) {
          this.$set(this.isContent, i, true)
        } else {
          this.$set(this.isContent, i, false)
        }
      }
    },
    goToCaseDetail (keyword) {
      // setStore("keywords",keyword)
      // setStore('areaChina', 'shewai')
      window.location.href = '/case.html#/casesList?areas=null&type=' + keyword
    },
    newgoToCaseDetail (type) {
      let currentLa = localStorage.getItem('locale')
      if (currentLa === 'en_US') {
        currentLa = 'en'
      } else if (currentLa === 'zh_TW') {
        currentLa = 'tc'
      } else {
        currentLa = 'zh'
      }
      // window.open(config.searchCaseUrl + '/?lang=' + currentLa + '&path=' + type + '#/casesHnswkb')
      window.open('https://law.odrcloud.cn/gd-fa/index')
    },
    goToLawDeatil (id) {
      setStore('keywords', '粤港澳')
      setStore('lawkeywords', '粤港澳')
      setStore('areaChina', 'dalu')
      window.location.href = `/law.html#/lawDetail?keywords=["粤港澳"]&ID=${id}&areas=null`
    },
    mediation () {
      let logininfo = JSON.parse(getStore('loginInfouser'))
      if (logininfo) {
        let userInfo = JSON.parse(getStore('loginInfouser')).userInfo
        if (userInfo.isRealName !== true) {
          this.$refs.status.statuss = true
        } else {
          window.location.href = '/selectcharacter'
        }
      } else {
        setStore('tolink', '/selectcharacter')
        window.location.href = '/useraction/login'
      }
    },
    // 语言
    toggleLang (lang) {
      if (lang === 'zh_CN') {
        localStorage.setItem('locale', 'zh_CN')
        this.lang = localStorage.getItem('locale')
        this.$message({
          message: '切换为中文！',
          type: 'success'
        })
      } else if (lang === 'en_US') {
        localStorage.setItem('locale', 'en_US')
        this.lang = localStorage.getItem('locale')
        this.$message({
          message: 'Switch to English!',
          type: 'success'
        })
      } else if (lang === 'zh_TW') {
        localStorage.setItem('locale', 'zh_TW')
        this.lang = localStorage.getItem('locale')
        this.$message({
          message: '切換為中文！',
          type: 'success'
        })
      }
      window.location.reload()
    },
    getMore () {
      if (this.isShowCard) {
        this.isup = false
        this.isShowCard = false
      } else {
        this.isup = true
        this.isShowCard = true
      }
    },
    // toWs(index) {
    //   var alink = document.createElement("a");
    //   alink.setAttribute("href", "/mediation.html");
    //   alink.click();
    // },
    tolink () {
      //      let logininfo = JSON.parse(getStore("loginInfouser"));
      //      let linkurl = "";
      //      if (logininfo) {
      //        //        linkurl = "/userCenter/center/third";
      //        linkurl = "https://www.gzinternetcourt.gov.cn";
      //      } else {
      //        setStore("tolink", "/userCenter/center/third");
      //        //        linkurl = "/useraction/login";
      //        linkurl = "https://www.gzinternetcourt.gov.cn";
      //      }
      window.location.href = 'https://www.gzinternetcourt.gov.cn'
    },
    // 跳转注册
    goregister () {
      setStore('loginPosition', 'home')
      window.location.href = '/useraction/register'
    },
    // 跳转到公道登录界面
    goGd () {
      gongdaoLoginSkip().then(res => {
        if (res.data.code === 1000) {
          window.location.href = res.data.data
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    getlogin () {
      const url = window.location.href
      const states = url.split('&')
      if (states.length === 2) {
        let states_code = states[0].split('?')[1].split('=')[1]
        let state = states[1].split('=')[1]
        getGongdaoLoginToken(states_code, state).then(res => {
          if (res.data.code === 1000) {
            let data = res.data.data
            removeStore('loginInfo')
            removeStore('loginInfouser')
            setStore('dddddd', data.gondaoLogin)
            setStore('authToken', data.authToken)
            setStore('refreshToken', data.refreshToken)
            if (this.currTab === 0) {
              setStore('loginInfouser', data.loginInfo)
              let tolink = getStore('tolink')
              if (data.loginInfo.userInfo.isRealName) {
                if (tolink) {
                  // 是否有重定向的页面
                  if (tolink.indexOf('/mediation') > -1) {
                    // 如果是要跳到纠纷调解页面，
                    // 已实名的话，不用调回纠纷调解页面，直接跳到选择角色页面
                    // 如果未实名，则调回纠纷调节页面，实名后跳到选择角色页面
                    if (data.loginInfo.userInfo.isRealName) {
                      let urlSuffix = tolink.substr(
                        tolink.indexOf('?'),
                        tolink.length
                      )
                      window.location.href = `/selectcharacter${urlSuffix}`
                      removeStore('tolink')
                    } else {
                      this.$router.push('/authonIden')
                    }
                  } else {
                    window.location.href = tolink
                    removeStore('tolink')
                  }
                } else {
                  // 如果是游客模式新建咨询，进入和咨询师聊天页面，在聊天页面点击登录，登录后在首页
                  let isFromChatOnline =
                    document.referrer.indexOf('consultation/chatOnline') !== -1
                  if (isFromChatOnline) {
                    window.location.href = '/home.html'
                  } else {
                    window.location.href = '/userCenter/center'
                  }
                }
              } else {
                var aLink = document.createElement('a')
                aLink.setAttribute('href', '/authonIden')
                aLink.click()
              }
            } else if (this.currTab === 1) {
              setStore('loginInfo', data.loginInfo)
              // 登录跳转
              let redicturl = this.getredicturl(data.loginInfo)
              setStore('redicturl', redicturl)
              window.location.href = redicturl
            }
          } else {
            this.reserror = res.data.message
            this.showreserror = true
            setTimeout(() => {
              this.showreserror = false
            }, 2000)
          }
        })
      } else {
        history.go(-1)
      }
    },
    showMessage (routerLink) {
      //   this.showMes = true;
      //   this.$confirm(
      //     "本次咨询仅供参考，不能替代任何司法判决或证据使用，不能代表广州互联网法院观点。",
      //     "提示",
      //     {
      //       confirmButtonText: "确定",
      //       cancelButtonText: "取消",
      //       type: "warning",
      //       center: true
      //     }
      //   )
      //     .then(() => {
      this.showMes = false
      window.open(routerLink, '_blank')
      //     })
      //     .catch(() => {});
      //   console.log("router=>>>>>>", routerLink);
    },
    // 已经登录
    hasLogined () {
      this.logininfos = JSON.parse(getStore('loginInfouser'))
      let logininfo = JSON.parse(getStore('loginInfouser'))
      if (logininfo) {
        let phone = logininfo.userInfo.mobilePhone
        this.mobilephone = phone.substr(0, 3) + '****' + phone.substr(7, 4)
        this.userSex = logininfo.userInfo.sex
        if (logininfo.userInfo.headPortraitUrl) {
          this.headUrl = logininfo.userInfo.headPortraitUrl
        }
        if (logininfo.userInfo.isRealName) {
          this.isRealName = true
          this.mobilephone = logininfo.userInfo.userName
        }
        this.islogin = true
      }
    },
    // 实名认证的跳转
    isRealName1 () {
      let logininfo = JSON.parse(getStore('loginInfouser'))
      let aLink = document.createElement('a')
      if (logininfo.userInfo.isRealName) {
        aLink.setAttribute('href', '/userCenter/center/third')
        aLink.click()
      } else {
        aLink.setAttribute('href', '/goToApplets')
        aLink.click()
      }
    },
    // 立即咨询
    consultation () {
      this.conTime()
    },
    conTime () {
      let that = this
      var time_range = function (beginTime1, endTime1, beginTime2, endTime2) {
        var strb = beginTime1.split(':')
        if (strb.length != 2) {
          return false
        }
        var stre = endTime1.split(':')
        if (stre.length != 2) {
          return false
        }
        var strf = beginTime2.split(':')
        if (strf.length != 2) {
          return false
        }
        var strg = endTime2.split(':')
        if (strg.length != 2) {
          return false
        }
        var b = new Date()
        var e = new Date()
        var f = new Date()
        var g = new Date()
        var n = new Date()
        b.setHours(strb[0])
        b.setMinutes(strb[1])
        e.setHours(stre[0])
        e.setMinutes(stre[1])
        f.setHours(strf[0])
        f.setMinutes(strf[1])
        g.setHours(strg[0])
        g.setMinutes(strg[1])
        if (
          (n.getTime() - b.getTime() > 0 &&
            n.getTime() - e.getTime() < 0 &&
            n.getDay() != 6 &&
            n.getDay() != 0) ||
          (n.getTime() - f.getTime() > 0 &&
            n.getTime() - g.getTime() < 0 &&
            n.getDay() != 6 &&
            n.getDay() != 0)
        ) {
          if (that.logininfos) {
            // 工作时间
            window.location.href = '/mediation.html'
            //            window.location.href = "/onlineMediation/step1/0";
          } else {
            that.isCustomer = true
            that.dialogTableVisiblePeoTime = true
          }
          return true
        } else {
          if (that.logininfos) {
            that.isCustomer = false
          } else {
            that.isCustomer = false
          }
          that.dialogTableVisiblePeoNoTime = false // 非工作时间
          return false
        }
      }
      time_range('9:00', '11:30', '13:30', '18:00')
    },
    handleClose1 () {
      this.dialogTableVisiblePeoTime = false
    },
    handleClose2 () {
      this.dialogTableVisiblePeoNoTime = false
    },
    handleClose3 () {
      this.dialogTableVisibleFta = false
    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    openFta () {
      this.dialogTableVisibleFta = true
    },
    handleCloseEnter () {
      window.location.href = '/mediation.html'
    },
    tolink (type) {
      if (!type) {
        return
      }
      let logininfo = getStore('loginInfouser')
      let linkurl = ''
      if (logininfo) {
        switch (type) {
          case 'susong':
            linkurl = '/userCenter/center/fourth'
            break
          default:
        }
      } else {
        setStore('tolink', '/userCenter/center/fourth')
        linkurl = '/useraction/login'
      }
      window.location.href = linkurl
    },
    loginout () {
      if (getStore('dddddd')) {
        logoutOptions().then(
          res => {
            removeStore('authToken')
            removeStore('refreshToken')
            removeStore('loginInfouser')
            removeStore('dddddd')
            this.islogin = false
            const redir = document.getElementById('redir')
            redir.setAttribute(
              'src',
              'https://www.gzinternetcourt.gov.cn/oauth/logout.do'
            )
          },
          erro => {
            this.$message.error(res.data.message)
          }
        )
      } else {
        logoutOptions().then(
          res => {
            removeStore('authToken')
            removeStore('refreshToken')
            removeStore('loginInfouser')
            removeStore('dddddd')

            this.islogin = false
          },
          erro => {
            this.$message.error(res.data.message)
          }
        )
      }
    },
    completeRealName (statuss) {
      if (!statuss) {
        // 认证成功
        window.location.href = `/peoMediation/step1/normal`
      }
    },
    mediation () {
      let logininfo = JSON.parse(getStore('loginInfouser'))
      if (logininfo) {
        let userInfo = JSON.parse(getStore('loginInfouser')).userInfo
        if (userInfo.isRealName !== true) {
          this.$refs.status.statuss = true
        } else {
          window.location.href = '/selectcharacter'
        }
      } else {
        setStore('tolink', '/selectcharacter')
        window.location.href = '/useraction/login'
      }
    }
  }
}
</script>

<style lang="scss">
.myrow {
  width: 1120px;
  margin: 0 auto;
}
.el-header,
.el-main,
.el-footer {
  padding: 0;
  min-width: 1140px;
}
.clear::after {
  content: '';
  display: block;
  clear: both;
}
.el-button.is-plain:focus,
.el-button.is-plain:hover {
  background: #fff;
  border-color: #3595f4;
  color: #3595f4;
}
.noShow {
  display: none;
}
.change {
  transform: rotate(180deg);
}
.ftaDialog {
  .el-dialog {
    height: 500px;
    .el-dialog__header {
      .el-dialog__title {
        font-family: PingFang-SC-Medium;
        font-size: 14px;
        font-weight: bold;
        color: #333333;
        position: relative;
        padding-left: 16px;
      }
      .el-dialog__title:before,
      .el-dialog__title:after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 3px;
        height: 9px;
        background-color: #f9b439;
        z-index: 1;
      }
      .el-dialog__title:after {
        height: 18px;
        background-color: #3595f4;
        z-index: 0;
      }
    }
    .el-dialog__body {
      padding: 0;
      height: 446px;
      max-height: 446px;
      .el-tabs__header {
        margin: 0;
        .el-tabs__nav {
          float: none;
          text-align: center;
        }
        .el-tabs__nav-wrap::after {
          width: 0;
        }
        .el-tabs__active-bar {
          width: 40px !important;
          left: 291px;
          height: 3px;
        }
        .el-tabs__item {
          font-family: PingFang-SC-Medium;
          font-size: 14px;
          font-weight: bold;
          height: 46px;
        }
      }
      .el-tabs__content {
        height: 400px;
        max-height: 400px;
        background-color: #f5f5f5;
        .el-scrollbar {
          height: 380px;
          margin: 10px 20px;
          background-color: #ffffff;
          border-radius: 0px 2px 0px 0px;
          border: solid 1px #e6e6e6;
          .el-scrollbar__wrap {
            overflow-x: hidden;
            .el-scrollbar__view {
              margin: 39px 42px 36px 51px;
              font-size: 14px;
              color: #666666;
              & > div {
                & > p {
                  margin-bottom: 15px;
                  line-height: 22px;
                }
              }
            }
          }
        }
      }
    }
  }
}
.peoDialog {
  .el-dialog {
    .el-dialog__header {
      border-bottom: 1px solid #e5e5e5;
      padding: 15px 40px 10px;
    }
    .el-dialog__body {
      .conDialog {
        display: flex;
        display: -webkit-flex;
        padding: 0 26px;
        .sucess-peo {
          width: 60px;
          height: 60px;
          padding-right: 14px;
        }
        .tipDialog {
          span {
            display: block;
          }
          .sucess-sub {
            font-size: 14px;
            line-height: 24px;
            color: #666666;
          }
          .sucess-center {
            font-family: PingFang-SC-Regular;
            font-size: 14px;
            color: #b2b2b2;
          }
        }
      }
      .el-button--primary {
        background-image: linear-gradient(90deg, #22b9ff 0%, #3d86ef 100%),
          linear-gradient(#d8dfef, #d8dfef);
      }
      .sucess-btn {
        padding-top: 30px;
        text-align: center;
        .btn {
          margin: 0 13px;
          padding: 7px 32px;
        }
      }
    }
  }
}
.el-header {
  .topbar {
    background-color: #ececec;
    height: 30px;
    line-height: 30px;
    .action-left {
      float: left;
      span {
        color: #9b9999;
        cursor: pointer;
        display: inline-block;
        font-size: 14px;
      }
      span:hover {
        color: #666;
      }
    }
    .action-right {
      float: right;
      font-size: 12px;
      color: #888;
      a {
        color: #888;
        padding: 0 5px;
      }
      .split {
        width: 1px;
        height: 9px;
        background-color: #ccc;
        display: inline-block;
      }
      .phone {
        padding: 0 5px;
        cursor: pointer;
        background: url(../../module/home/img/icon_phone.png) no-repeat 5px
          center;
        padding-left: 20px;
        display: inline-block;
        position: relative;
        img {
          position: absolute;
          right: -30px;
          top: 28px;
          background-color: #fff;
          padding: 0px;
          z-index: 10;
          width: 110px;
          height: 110px;
          padding: 10px;
          border: 1px solid #e6e6e6;
          border-radius: 4px;
        }
      }
    }
  }
}
.home {
  .lawsuit-third {
    height: 600px;
    background: url(./img/lawsuit_bg.png) no-repeat center center #fff;
    background-size: cover;
    .action-btn {
      width: 110px;
      height: 36px;
      line-height: 36px;
      margin: 0 auto;
      background-color: #3595f4;
      border-radius: 4px;
      font-size: 16px;
      color: #fff;
      text-align: center;
      cursor: pointer;
      &:hover {
        background: linear-gradient(to right, #22b9ff, #3d86ef);
        box-shadow: 0px 0px 18px 4px rgba(1, 86, 218, 0.3);
        color: #fff;
      }
    }
  }
  .box-h {
    text-align: center;
    padding: 60px 0 57px;
  }
  .h5tit {
    font-size: 24px;
    color: #333;
  }
  .pdesc {
    /*padding-top: 15px;*/
    font-size: 14px;
    color: #999;
  }
  .line {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    span {
      display: inline-block;
      width: 130px;
      border-bottom: 2px dotted #b2b2b2;
      margin: 0 20px;
    }
    .orange {
      background-color: #f0a635;
    }
    .blue {
      background-color: #3595f4;
    }
  }
  .talk-service {
    position: fixed;
    right: 10px;
    top: 53%;
    margin-top: -20px;
    width: 135px;
    height: 143px;
    background: url(../../module/home/img/service.png) no-repeat center center;
    background-size: 100%;
    z-index: 99;
    a {
      display: block;
      height: 100%;
      width: 100%;
    }
  }
  .partners {
    padding-bottom: 70px;
    background-color: #fff;
    .partners-img {
      width: 1040px;
      margin: 0 auto;
      text-align: center;
    }
  }
  .service-source {
    overflow: hidden;
    height: 284px;
    background: url(./img/severse2.png) no-repeat center;
    background-size: cover;
    .service-div1 {
      @extend .common-title;
      color: #fff;
      margin: 41px auto 84px auto;
    }
    ul {
      width: 1100px;
      margin: 0 auto;
      li {
        width: 274px;
        // width: 33.3%;
        margin: 0 auto;
        text-align: center;
        float: left;
        h6 {
          font-size: 34px;
          font-weight: 300;
          color: #fff;
        }
        p {
          font-size: 18px;
          color: #fff;
          padding-top: 10px;
        }
      }
    }
  }
  .case-count {
    height: 56px;
    background-color: #f5f5f5;
    .count-box {
      width: 100%;
      div {
        float: right;
        margin-right: 104px;
        font-weight: 500;
        line-height: 30px;
        font-size: 16px;
        letter-spacing: 5px;
        span {
          display: inline-block;
          width: 24px;
          height: 30px;
          margin: 13px 2px;
          font-size: 20px;
          line-height: 30px;
          text-align: center;
          font-weight: 500;
          color: #3595f4;
          font-weight: bold;
          background-image: url('img/numbg.png');
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
        p {
          display: inline-block;
          font-size: 14px;
          color: #999;
        }
      }
    }
  }
  .law-consult {
    background: #fff;
    padding-bottom: 70px;
    ul {
      width: 1080px;
      margin: 30px auto 0;
      li {
        background-color: #fff;
        width: 470px;
        /*height: 390px;*/
        height: 266px;

        float: left;
        margin: 0 35px;
        position: relative;
        box-shadow: 0 3px 12px 4px rgba(208, 208, 208, 0.3);
        i {
          display: block;
          width: 80px;
          height: 80px;
          /*background: url(../../module/home/img/portrait.png) no-repeat;*/
          position: absolute;
          top: -40px;
          left: 50%;
          margin-left: -39px;
        }
        .icon01 {
          /*background-position: 0 0;*/
          background: url(../../module/home/img/portrait_02.png) no-repeat;
          background-size: cover;
        }
        .icon02 {
          /*background-position: center bottom;*/
          background: url(../../module/home/img/portrait_01.png) no-repeat;
          background-size: cover;
        }
        h6 {
          font-size: 17.88px;
          color: #3595f4;
          text-align: center;
          padding: 50px 0 13px;
          font-weight: 700;
        }
        p {
          /*padding: 0 30px 10px;*/
          padding: 18px 30px 46px;
          font-size: 14px;
          line-height: 20px;
          color: #888;
        }
        img {
          width: 410px;
          height: 190px;
          display: block;
          margin: 0 auto;
        }
        a {
          display: block;
          width: 110px;
          height: 36px;
          line-height: 36px;
          background-color: #3595f4;
          text-align: center;
          font-size: 16px;
          font-weight: 300;
          margin: 15px auto 0;
          color: #fff;
          border-radius: 4px;
          &:hover {
            background: linear-gradient(to right, #22b9ff, #3d86ef);
            box-shadow: 0px 3px 16px 4px rgba(191, 232, 219, 0.27);
            color: #fff;
          }
        }
      }
    }
  }
  .common-title {
    position: relative;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    & > span:nth-of-type(1) {
      font-size: 30px;
    }
    & > span:nth-of-type(2) {
      font-size: 24px;
      opacity: 0.7;
      margin-left: 21px;
    }
    &:after {
      content: '';
      position: absolute;
      bottom: -13px;
      left: 0;
      width: 45px;
      height: 4px;
      background-color: #3595f4;
    }
  }
  .fta-box {
    height: 450px;
    background: url(./img/bottom-one.png) no-repeat center;
    background-size: cover;
    position: relative;
    overflow: hidden;
    .fta-box-main {
      width: 1200px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
    .fta-main {
      width: 1920px;
      height: 204px;
      background: url(./img/section.png) no-repeat center;
      background-size: cover;
      position: absolute;
      top: 116px;
      left: 50%;
      transform: translateX(-50%);
      .fta-item {
        position: absolute;
        text-align: center;
        .fta-item-title {
          font-family: PingFang-SC-Bold;
          font-size: 17px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #333333;
        }
        .fta-item-text {
          font-family: PingFang-SC-Regular;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #444444;
          margin-top: 20px;
        }
      }
      .fta-item1 {
        left: 455px;
        top: 152px;
        width: 154px;
      }
      .fta-item2 {
        left: 832px;
        top: 227px;
        width: 168px;
      }
      .fta-item3 {
        left: 1209px;
        top: 131px;
        width: 142px;
      }
    }
    .dispute-numbox {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 30px;
      margin-left: -32px;
      .numtitle {
        font-family: PingFang-SC-Medium;
        font-size: 19px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 30px;
        letter-spacing: 1px;
        color: #333333;
      }
      .numbox {
        margin: 0 12px;
        span {
          display: inline-block;
          width: 34px;
          height: 40px;
          margin: 0px 9px;
          font-size: 24px;
          line-height: 40px;
          text-align: center;
          font-family: zcoolqingkehuangyouti-Regular;
          font-weight: normal;
          color: #ffffff;
          background-image: linear-gradient(0deg, #7ec2e4 0%, #619cc0 100%),
            linear-gradient(#ffffff, #ffffff);
          background-blend-mode: normal, normal;
          box-shadow: 0px 3px 7px 0px rgba(53, 150, 244, 0.25);
          border-radius: 3px;
          /*background-image: url("img/numbg.png");*/
          /*background-repeat: no-repeat;*/
          /*background-size: 100% 100%;*/
        }
      }
    }
    .fta-btnbox {
      width: 68px;
      height: 68px;
      position: absolute;
      right: 0;
      top: 33px;
      background-color: rgba(0, 0, 0, 0.25);
      box-shadow: 0px 5px 10px 0px rgba(39, 182, 255, 0.35);
      border-radius: 2px 0px 0px 2px;
      text-align: center;
      .fta-divtext {
        font-family: PingFang-SC-Medium;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 9px;
        letter-spacing: 0px;
        color: #ffffff;
      }
      .fta-img {
        width: 40px;
        height: 35px;
        margin: 8px auto;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .fta-btnbox:hover {
      cursor: pointer;
    }
  }
  .case-box {
    height: 679px;
    background: url(./img/casebase.png) no-repeat center;
    background-size: cover;
    color: #ffffff;
    overflow: hidden;
    & > div {
      /*margin: auto 80px;*/
    }
    .casebase-div1 {
      @extend .common-title;
      margin-top: 42px;
    }
    .casebase-div2 {
      margin-top: 45px;
      height: 504px;
      display: flex;
      /*grid-template-columns: 520px 580px 282px 282px;*/
      justify-content: space-between;
      align-content: space-between;
      .div2-left {
        width: 520px;
        height: 100%;
        margin-right: 21px;
        display: flex;
        align-items: center;
        background-image: linear-gradient(
            90deg,
            #5d7eb3 0%,
            #7491c0 0%,
            #8ba4cc 0%,
            #76a0c6 0%,
            #619cbf 0%,
            #68b5dd 100%
          ),
          linear-gradient(#ffffff, #ffffff);
        background-blend-mode: normal, normal;
        border-radius: 2px;
        .content-box {
          margin: 0 50px;
          .content-title {
            font-family: PingFang-SC-Regular;
            font-size: 30px;
            font-weight: 300;
            font-stretch: normal;
            letter-spacing: 0px;
          }
          .content-text {
            height: 204px;
            font-size: 20px;
            line-height: 40px;
            margin: 42px 0 32px 0;
            word-break: break-all;
            word-wrap: break-word;
            overflow: hidden;
            text-overflow: ellipsis; // 文本溢出显示省略号
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 5; // 只显示5行文本
          }
          .content-btn {
            width: 136px;
            height: 42px;
            background-color: #bfdbe9;
            border-radius: 2px;
            .el-button.el-button--warning.is-plain {
              width: 100%;
              font-size: 16px;
              color: #619cbf;
              border-radius: 2px;
              background-color: #bfdbe9;
              &:hover,
              &:focus {
                color: #fff;
                background: #3595f4;
              }
            }
          }
        }
      }
      .div2-right {
        width: 580px;
        height: 100%;
        display: grid;
        align-content: space-between;

        .hover-box {
          position: relative;
          &:after,
          &:before {
            content: '';
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
            z-index: 0;
            /*transition: all .3s linear;*/
          }
          &:hover:before {
            z-index: 1;
          }
          &:hover {
            cursor: pointer;
          }
        }

        .right-top {
          height: 250px;
          text-align: center;
          &:after {
            background-image: url(./img/high-off.png);
          }
          &:before {
            background-image: url(./img/high-on.png);
          }
          .top-title {
            font-family: PingFang-SC-Regular;
            font-size: 22px;
            font-weight: 300;
            font-stretch: normal;
            margin-top: 176px;
            position: relative;
            z-index: 2;
          }
        }
        .right-down {
          height: 237px;
          display: flex;
          justify-content: space-between;
          text-align: center;
          & > div {
            width: 282px;
            background-color: #0d96ff;
            .down-title {
              font-family: PingFang-SC-Regular;
              font-size: 22px;
              font-weight: 300;
              font-stretch: normal;
              margin-top: 152px;
              position: relative;
              z-index: 2;
            }
          }
          .down-div1 {
            &:after {
              background-image: url(./img/gangao-off.png);
            }
            &:before {
              background-image: url(./img/gnagao-on.png);
            }
          }
          .down-div2 {
            &:after {
              background-image: url(./img/shewai-off.png);
            }
            &:before {
              background-image: url(./img/shewai-on.png);
            }
          }
        }
      }
    }
  }
  .law-box {
    height: 544px;
    background: url(./img/law-bg.png) no-repeat center;
    background-size: cover;
    color: #ffffff;
    overflow: hidden;
    & > div {
      /*margin: auto 80px;*/
    }
    .law-div1 {
      @extend .common-title;
      margin-top: 40px;
    }
    .law-main {
      height: 392px;
      margin-top: 21px;
      position: relative;
      .law-morebtn {
        position: absolute;
        top: -39px;
        right: 0;
        height: 16px;
        font-family: PingFang-SC-Medium;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #ffffff;
        opacity: 0.7;
      }
      .law-maindiv {
        width: 560px;
        float: right;
        & > div {
          width: 560px;
          height: 120px;
          box-shadow: 0px 1px 7px 0px rgba(53, 150, 244, 0.3);
          border-radius: 2px;
          position: relative;
          display: flex;
          align-items: center;
          background-color: rgba(255, 255, 255, 0.95);
          & > .law-item {
            margin: 0 46px 0 73px;
            & > .lawitem-title {
              font-family: PingFang-SC-Medium;
              font-size: 18px;
              color: #363636;
              line-height: 20px;
              word-break: break-all;
              word-wrap: break-word;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              /* autoprefixer: off */
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
            }
            & > .lawitem-text {
              font-family: PingFang-SC-Medium;
              font-size: 14px;
              line-height: 20px;
              color: #666666;
              margin-top: 18px;
              word-break: break-all;
              word-wrap: break-word;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
            }
          }
          & > .law-time {
            position: absolute;
            top: 26px;
            left: -46px;
            width: 82px;
            height: 68px;
            background-image: linear-gradient(-90deg, #4dafea 0%, #53cbcc 100%),
              linear-gradient(#35c0f4, #35c0f4);
            background-blend-mode: normal, normal;
            border-radius: 2px;
            text-align: center;
            & > span {
              display: block;
              font-family: PingFang-SC-Medium;
            }
            & > span:nth-child(1) {
              font-size: 28px;
              letter-spacing: 1px;
              margin: 8px auto 7px auto;
            }
            & > span:nth-child(2) {
              font-size: 18px;
            }
          }
        }
        & > div:hover {
          cursor: pointer;
        }
        & > div:nth-child(1) {
          background-color: #ffffff;
        }
        & > div:nth-child(2) {
          margin: 16px 0;
        }
      }
      .law-bgimg {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        background-size: auto;
        background: url(./img/law.png) no-repeat 61px center;
        animation: heart 1.3s ease-in-out 2.7s infinite alternate;
      }
    }
    @keyframes heart {
      from {
        transform: translate(0, 0);
      }
      to {
        transform: translate(0, 7px);
      }
    }
  }
  .law-one {
    background: #fff;
    padding-bottom: 70px;
    .line span {
      background-color: #e0e0e0;
    }
    .el-row {
      width: 1250px;
      margin: 3px auto 0;
      .fist-news {
        margin-bottom: 40px;
        a {
          display: block;
          display: flex;
          color: #666;
          img {
            margin-right: 30px;
            width: 230px;
            height: 160px;
          }
          .title {
            color: #333333;
            padding: 12px 0 18px;
          }
          .time {
            font-size: 14px;
            display: block;
            padding-bottom: 24px;
            color: #d3d3d3;
          }
          .content {
            font-size: 14px;
            line-height: 24px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
          }
        }
      }
      .other-news {
        //   margin-top: 40px;
        margin-bottom: 30px;
        a {
          display: block;
          display: flex;
          justify-content: space-between;
          color: #666;
          // width: 660px;
          //   .cir {
          //       background-color: #3595f4;
          //       width: 4px;
          //       height: 4px;
          //       border-radius: 50%;
          //   }
          .title::before {
            content: '';
            display: inline-block;
            background-color: #3595f4;
            width: 4px;
            height: 4px;
            border-radius: 50%;
            transform: translateY(-4px);
            margin-right: 12px;
          }
          .time {
            color: #d3d3d3;
            font-size: 14px;
          }
        }
      }
    }
  }
  .law-consult-two {
    background: url(./img/consult_bg.png) no-repeat center #f1f7f6;
    padding-bottom: 10px;
    background-size: cover;
    .h5tit,
    .pdesc {
      color: #fff;
    }
    .more {
      color: #999;
      position: absolute;
      right: 0;
    }
    .more-btn {
      text-align: center;
      padding: 20px 0 57px;
      img {
        width: 24px;
      }
    }
    div.clearfix {
      width: 1110px;
      margin: 3px auto 0;
      .el-col.el-col-24 {
        width: 342px;
        margin-right: 28px;
        margin-bottom: 18px;
        img {
          width: 100%;
        }
        .el-card {
          overflow: visible;
        }
        .el-card .el-card__body {
          position: relative;
          img.cir {
            position: absolute;
            width: 20%;
            top: -34px;
            left: 136px;
          }
        }
        //  添加
        .card-body {
          padding: 20px 10px 0;
          h6 {
            font-size: 17.88px;
            color: #222;
            margin-bottom: 15px;
            font-weight: 500;
            // overflow: hidden;
            // text-overflow: ellipsis;
            // white-space: nowrap;
          }
          p {
            font-size: 14px;
            line-height: 26px;
            color: #888;
            // margin-bottom: 16px;
            // height: 122px;
            // overflow: hidden;
            // text-overflow: ellipsis;
            margin-bottom: 26px;
            height: 154px;
            word-break: break-all;
            word-wrap: break-word;
            overflow: hidden;
            text-overflow: ellipsis; //文本溢出显示省略号
            display: -webkit-box;
            /* autoprefixer: off */
            -webkit-box-orient: vertical;
            /* autoprefixer: on */
            -webkit-line-clamp: 6; // 只显示3行文本
          }
          .card-btn {
            padding-left: 90px;

            .el-button.el-button--warning.is-plain {
              width: 110px;
              background: #fff;
              &:hover,
              &:focus {
                color: #fff;
                background: #3595f4;
              }
            }
          }
        }
        &.last-card {
          margin-right: 0px;
        }
      }
    }
    .mediate-btn {
      width: 110px;
      background-color: #ffffff;
      border-radius: 4px;
      border: solid 1px #ffffff;
      display: block;
      margin: 0 auto;
      font-size: 16px;
      line-height: 18px;
      color: #3595f4;
      padding: 8px 0;
      margin-top: 35px;
    }
    .dispute-type {
      display: block;
      margin: 0 auto;
      cursor: default;
    }
    ul {
      width: 1020px;
      margin: 30px auto 0;
      li {
        background-color: #fff;
        width: 440px;
        float: left;
        margin: 0 35px;
        position: relative;
        padding: 20px 0 30px;
        border-radius: 4px;
        i {
          display: block;
          width: 78px;
          height: 80px;
          background: url(../../module/home/img/portrait.png) no-repeat;
          position: absolute;
          top: -40px;
          left: 50%;
          margin-left: -39px;
        }
        .icon01 {
          background-position: 0 0;
        }
        .icon02 {
          background-position: center bottom;
        }
        p {
          padding: 10px 30px 20px;
          font-size: 14px;
          line-height: 20px;
          color: #888;
        }
        img {
          width: 400px;
          height: 220px;
          display: block;
          margin: 0 auto;
        }
        a {
          width: 100px;
          height: 40px;
          background-color: #ffffff;
          border-radius: 4px;
          border: solid 1px #3595f4;
          display: block;
          line-height: 40px;
          text-align: center;
          font-size: 16px;
          font-weight: 300;
          margin: 10px auto 15px;
          color: #3595f4;
          &:hover {
            /*background: linear-gradient(to right, #2278da, #3595f4);*/
            background: linear-gradient(to right, #22b9ff, #3d86ef);
            box-shadow: 0px 0px 18px 4px rgba(1, 86, 218, 0.3);
            color: #fff;
          }
        }
      }
    }
  }
  .defuse-dispute {
    background-color: #fff;
    padding-bottom: 80px;
    ul {
      width: 1160px;
      margin: 0 auto;
      li {
        width: 310px;
        float: left;
        padding: 0 37px;
        border-right: 1px solid #dce7ef;
        h6 {
          font-size: 19px;
          color: #222;
        }
        p {
          font-size: 13px;
          color: #888;
          padding: 10px 0 15px;
        }
        img {
          display: block;
          width: 310px;
          height: 165px;
        }
        a {
          display: block;
          padding-top: 15px;
          color: #3595f4;
          font-size: 15.46px;
          &::after {
            display: inline-block;
            content: '';
            width: 12px;
            height: 12px;
            background: url(../../module/home/img/icon_circle_right.png)
              no-repeat right center;
            background-size: 12px 12px;
            padding-left: 6px;
          }
        }
        &:last-child {
          border: none;
        }
      }
    }
  }
  .online-defuse {
    background-color: #fff;
    padding-bottom: 80px;
    ul {
      width: 1105px;
      margin: 0 auto;
      li {
        width: 296px;
        height: 250px;
        background-color: #fff;
        // box-shadow: 0 0 1px 1px rgba(206, 206, 206, 0.5);
        float: left;
        margin: 0 35px;
        text-align: center;
        img {
          margin: 45px auto 40px;
          display: block;
          width: 106px;
          height: 98px;
          /*background: url(../../module/home/img/icon_feature.png) no-repeat;*/
        }
        .icon01 {
          background: url(../../module/home/img/icon_feature01.png) no-repeat;
          background-size: cover;
        }
        .icon02 {
          background: url(../../module/home/img/icon_feature02.png) no-repeat;
          background-size: cover;
        }
        .icon03 {
          background: url(../../module/home/img/icon_feature03.png) no-repeat;
          background-size: cover;
        }
        .icon04 {
          background: url(../../module/home/img/icon_feature04.png) no-repeat;
          background-size: cover;
        }
        div {
          font-size: 17px;
          color: #333;
        }
        p {
          padding-top: 5px;
          font-size: 13px;
          color: #999;
        }
      }
    }
  }
  .btnlr-gradient {
    background: -webkit-linear-gradient(to right, #22b9ff, #3d86ef);
    background: -o-linear-gradient(to right, #22b9ff, #3d86ef);
    background: -moz-linear-gradient(to right, #22b9ff, #3d86ef);
    background: linear-gradient(to right, #22b9ff, #3d86ef);
    cursor: pointer;
  }
  .banner {
    width: 100%;
    position: relative;
    /*background: url(./img/banner_04.png) no-repeat center center;*/
    background-size: cover;
    height: 400px;
    .el-carousel {
      .slide-01 {
        background: url(./img/banner-new1.jpg) no-repeat center center;
        background-size: cover;
      }
      .slide-02 {
        background: url(./img/banner-new2.jpg) no-repeat center center;
        background-size: cover;
      }
      .slide-03 {
        background: url(./img/banner_04.png) no-repeat center center;
        background-size: cover;
        .threeLang {
          width: 1200px;
          margin: auto;
          position: relative;
        }
      }
    }
    .ban_word {
      width: 700px;
      position: absolute;
      top: 100px;
      left: 0;
      z-index: 1000;
    }
    .el-carousel__indicator.is-active button {
      background-color: #e7a32a;
    }
    .el-carousel__indicators {
      bottom: 5px;
    }
    .banner-actionbox {
      width: 1200px;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 100;
    }
    .banner-action {
      position: absolute;
      right: 0;
      top: 70px;
      width: 300px;
      height: 260px;
      background-color: #fff;
      border-radius: 5px;
      z-index: 10;
      .loginout {
        font-size: 14px;
        text-align: center;
        a {
          color: #3595f4;
        }
      }
      .usercenter {
        width: 248px;
        height: 40px;
        line-height: 40px;
        border-radius: 4px;
        margin: 24px auto;
        a {
          color: #fff;
          text-align: center;
          font-size: 18px;
          display: block;
        }
      }
      .welcome-login {
        font-size: 16px;
        color: #666;
        text-align: center;
      }
      img {
        display: block;
        width: 80px;
        height: 80px;
        margin: 20px auto;
        border-radius: 100px;
        overflow: hidden;
      }
      h6 {
        font-weight: normal;
        font-size: 14px;
        color: #666;
        text-align: center;
        padding: 40px 0 32px;
      }
      .register {
        width: 247px;
        height: 49px;
        line-height: 49px;
        border-radius: 4px;
        margin: 0 auto;
        box-shadow: 0px 0px 18px 4px rgba(1, 86, 218, 0.3);
        a {
          color: #fff;
          text-align: center;
          font-size: 18px;
          display: block;
        }
      }
      .login {
        font-size: 14px;
        color: #999;
        text-align: center;
        padding: 30px 0 28px;
        a {
          color: #3595f4;
        }
      }
      .others-login {
        font-size: 14px;
        width: 160px;
        text-align: center;
        height: 30px;
        line-height: 30px;
        border: 1px solid #3595f4;
        margin: 0 auto;
        border-radius: 20px;
        a {
          display: block;
          color: #3595f4;
          position: relative;
          &::after {
            position: absolute;
            right: 16px;
            top: 11px;
            display: inline-block;
            content: '';
            height: 6px;
            width: 6px;
            border-width: 1px 1px 0 0;
            border-color: #3595f4;
            border-style: solid;
            transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
          }
        }
        &:hover {
          border: 1px solid transparent;
          background: linear-gradient(to right, #22b9ff, #3d86ef);

          box-shadow: 0px 0px 18px 4px rgba(1, 86, 218, 0.3);
          a {
            color: #fff;
            &::after {
              border-color: #fff;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/module/home/home.vue